(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.Units = {}));
})(this, (function (exports) { 'use strict';

    var UnitOfMeasure;
    (function (UnitOfMeasure) {
        UnitOfMeasure[UnitOfMeasure["NA"] = 0] = "NA";
        UnitOfMeasure[UnitOfMeasure["PERCENT"] = 10] = "PERCENT";
        UnitOfMeasure[UnitOfMeasure["DEGREES_F"] = 100] = "DEGREES_F";
        UnitOfMeasure[UnitOfMeasure["DEGREES_C"] = 101] = "DEGREES_C";
        UnitOfMeasure[UnitOfMeasure["DEGREES_K"] = 102] = "DEGREES_K";
        UnitOfMeasure[UnitOfMeasure["PASCAL"] = 210] = "PASCAL";
        UnitOfMeasure[UnitOfMeasure["HECTOPASCAL"] = 211] = "HECTOPASCAL";
        UnitOfMeasure[UnitOfMeasure["KILOPASCAL"] = 212] = "KILOPASCAL";
        UnitOfMeasure[UnitOfMeasure["MEGAPASCAL"] = 213] = "MEGAPASCAL";
        UnitOfMeasure[UnitOfMeasure["GIGAPASCAL"] = 214] = "GIGAPASCAL";
        UnitOfMeasure[UnitOfMeasure["BAR"] = 220] = "BAR";
        UnitOfMeasure[UnitOfMeasure["MILLIBAR"] = 221] = "MILLIBAR";
        UnitOfMeasure[UnitOfMeasure["CENTIBAR"] = 222] = "CENTIBAR";
        UnitOfMeasure[UnitOfMeasure["DECIBAR"] = 223] = "DECIBAR";
        UnitOfMeasure[UnitOfMeasure["KILOBAR"] = 224] = "KILOBAR";
        UnitOfMeasure[UnitOfMeasure["MEGABAR"] = 225] = "MEGABAR";
        UnitOfMeasure[UnitOfMeasure["ATM"] = 230] = "ATM";
        UnitOfMeasure[UnitOfMeasure["INCH_MERCURY"] = 240] = "INCH_MERCURY";
        UnitOfMeasure[UnitOfMeasure["MILLIMETER_MERCURY"] = 241] = "MILLIMETER_MERCURY";
        UnitOfMeasure[UnitOfMeasure["CENTIMETER_MERCURY"] = 242] = "CENTIMETER_MERCURY";
        UnitOfMeasure[UnitOfMeasure["TORR"] = 250] = "TORR";
        UnitOfMeasure[UnitOfMeasure["MILLITORR"] = 251] = "MILLITORR";
        UnitOfMeasure[UnitOfMeasure["INCH_WATER"] = 260] = "INCH_WATER";
        UnitOfMeasure[UnitOfMeasure["MILLIMETER_WATER"] = 261] = "MILLIMETER_WATER";
        UnitOfMeasure[UnitOfMeasure["CENTIMETER_WATER"] = 262] = "CENTIMETER_WATER";
        UnitOfMeasure[UnitOfMeasure["POUND_SQUARE_INCH"] = 270] = "POUND_SQUARE_INCH";
        UnitOfMeasure[UnitOfMeasure["CUBIC_FEET_PER_MINUTE"] = 300] = "CUBIC_FEET_PER_MINUTE";
        UnitOfMeasure[UnitOfMeasure["CUBIC_FEET_PER_SECOND"] = 301] = "CUBIC_FEET_PER_SECOND";
        UnitOfMeasure[UnitOfMeasure["CUBIC_FEET_PER_HOUR"] = 302] = "CUBIC_FEET_PER_HOUR";
        UnitOfMeasure[UnitOfMeasure["CUBIC_METERS_PER_SECOND"] = 310] = "CUBIC_METERS_PER_SECOND";
        UnitOfMeasure[UnitOfMeasure["CUBIC_METERS_PER_MINUTE"] = 311] = "CUBIC_METERS_PER_MINUTE";
        UnitOfMeasure[UnitOfMeasure["CUBIC_METERS_PER_HOUR"] = 312] = "CUBIC_METERS_PER_HOUR";
        UnitOfMeasure[UnitOfMeasure["LITERS_PER_SECOND"] = 320] = "LITERS_PER_SECOND";
        UnitOfMeasure[UnitOfMeasure["LITERS_PER_MINUTE"] = 321] = "LITERS_PER_MINUTE";
        UnitOfMeasure[UnitOfMeasure["LITERS_PER_HOUR"] = 322] = "LITERS_PER_HOUR";
        UnitOfMeasure[UnitOfMeasure["US_GALLON_PER_SECOND"] = 330] = "US_GALLON_PER_SECOND";
        UnitOfMeasure[UnitOfMeasure["US_GALLON_PER_MINUTE"] = 331] = "US_GALLON_PER_MINUTE";
        UnitOfMeasure[UnitOfMeasure["US_GALLON_PER_HOUR"] = 332] = "US_GALLON_PER_HOUR";
        UnitOfMeasure[UnitOfMeasure["FEET_PER_SECOND"] = 400] = "FEET_PER_SECOND";
        UnitOfMeasure[UnitOfMeasure["FEET_PER_MINUTE"] = 401] = "FEET_PER_MINUTE";
        UnitOfMeasure[UnitOfMeasure["METERS_PER_SECOND"] = 410] = "METERS_PER_SECOND";
        UnitOfMeasure[UnitOfMeasure["METERS_PER_MINUTE"] = 411] = "METERS_PER_MINUTE";
        UnitOfMeasure[UnitOfMeasure["PARTS_PER_MILLION"] = 500] = "PARTS_PER_MILLION";
        UnitOfMeasure[UnitOfMeasure["PARTS_PER_BILLION"] = 501] = "PARTS_PER_BILLION";
        UnitOfMeasure[UnitOfMeasure["PARTS_PER_TRILLION"] = 502] = "PARTS_PER_TRILLION";
        UnitOfMeasure[UnitOfMeasure["PARTS_PER_QUADRILLION"] = 503] = "PARTS_PER_QUADRILLION";
        UnitOfMeasure[UnitOfMeasure["COUNT"] = 510] = "COUNT";
        UnitOfMeasure[UnitOfMeasure["COUNT_PER_CUBIC_CENTIMETER"] = 511] = "COUNT_PER_CUBIC_CENTIMETER";
        UnitOfMeasure[UnitOfMeasure["COUNT_PER_CUBIC_METER"] = 512] = "COUNT_PER_CUBIC_METER";
        UnitOfMeasure[UnitOfMeasure["COUNT_PER_CUBIC_FOOT"] = 513] = "COUNT_PER_CUBIC_FOOT";
        UnitOfMeasure[UnitOfMeasure["COUNT_PER_DECILITER"] = 514] = "COUNT_PER_DECILITER";
        UnitOfMeasure[UnitOfMeasure["COUNT_PER_LITER"] = 515] = "COUNT_PER_LITER";
        UnitOfMeasure[UnitOfMeasure["MILLIGRAMS_PER_CUBIC_METER"] = 600] = "MILLIGRAMS_PER_CUBIC_METER";
        UnitOfMeasure[UnitOfMeasure["KILOGRAMS_PER_CUBIC_METER"] = 601] = "KILOGRAMS_PER_CUBIC_METER";
        UnitOfMeasure[UnitOfMeasure["MICROGRAMS_PER_CUBIC_METER"] = 602] = "MICROGRAMS_PER_CUBIC_METER";
        UnitOfMeasure[UnitOfMeasure["KILOGRAMS_PER_LITER"] = 610] = "KILOGRAMS_PER_LITER";
        UnitOfMeasure[UnitOfMeasure["GRAMS_PER_MILLILITER"] = 620] = "GRAMS_PER_MILLILITER";
        UnitOfMeasure[UnitOfMeasure["METRIC_TON_PER_CUBIC_METER"] = 630] = "METRIC_TON_PER_CUBIC_METER";
        UnitOfMeasure[UnitOfMeasure["GRAMS_PER_CUBIC_CENTIMETER"] = 640] = "GRAMS_PER_CUBIC_CENTIMETER";
        UnitOfMeasure[UnitOfMeasure["PARTICLE_SIZE"] = 700] = "PARTICLE_SIZE";
        UnitOfMeasure[UnitOfMeasure["SPECTRUM"] = 800] = "SPECTRUM";
        UnitOfMeasure[UnitOfMeasure["MILLIVOLT"] = 900] = "MILLIVOLT";
        UnitOfMeasure[UnitOfMeasure["VOLT"] = 901] = "VOLT";
        UnitOfMeasure[UnitOfMeasure["KILOVOLT"] = 902] = "KILOVOLT";
        UnitOfMeasure[UnitOfMeasure["MILLIAMP"] = 910] = "MILLIAMP";
        UnitOfMeasure[UnitOfMeasure["AMP"] = 911] = "AMP";
        UnitOfMeasure[UnitOfMeasure["KILOAMP"] = 912] = "KILOAMP";
        UnitOfMeasure[UnitOfMeasure["NANOMETER"] = 1000] = "NANOMETER";
        UnitOfMeasure[UnitOfMeasure["MICROMETER"] = 1001] = "MICROMETER";
        UnitOfMeasure[UnitOfMeasure["MILLIMETER"] = 1002] = "MILLIMETER";
        UnitOfMeasure[UnitOfMeasure["CENTIMETER"] = 1003] = "CENTIMETER";
        UnitOfMeasure[UnitOfMeasure["METER"] = 1004] = "METER";
        UnitOfMeasure[UnitOfMeasure["KILOMETER"] = 1005] = "KILOMETER";
        UnitOfMeasure[UnitOfMeasure["NANOSECOND"] = 1100] = "NANOSECOND";
        UnitOfMeasure[UnitOfMeasure["MILLISECOND"] = 1101] = "MILLISECOND";
        UnitOfMeasure[UnitOfMeasure["SECOND"] = 1102] = "SECOND";
        UnitOfMeasure[UnitOfMeasure["LITER"] = 1200] = "LITER";
        UnitOfMeasure[UnitOfMeasure["MILLILITER"] = 1201] = "MILLILITER";
        UnitOfMeasure[UnitOfMeasure["CUBIC_FEET"] = 1210] = "CUBIC_FEET";
        UnitOfMeasure[UnitOfMeasure["RELATIVE_HUMIDITY"] = 1300] = "RELATIVE_HUMIDITY";
        UnitOfMeasure[UnitOfMeasure["RELATIVE_HUMIDITY_PERCENT"] = 1301] = "RELATIVE_HUMIDITY_PERCENT";
        UnitOfMeasure[UnitOfMeasure["DECIBELS"] = 1400] = "DECIBELS";
    })(UnitOfMeasure || (UnitOfMeasure = {}));
    var UnitOfMeasure$1 = UnitOfMeasure;

    var _a;
    var UnitOfMeasureProperties = Object.freeze((_a = {},
        _a[UnitOfMeasure$1.NA] = { name: 'N/A', value: UnitOfMeasure$1.NA, code: 'na' },
        _a[UnitOfMeasure$1.PERCENT] = { name: 'Percent', value: UnitOfMeasure$1.PERCENT, code: '%' },
        _a[UnitOfMeasure$1.DEGREES_F] = { name: 'Degrees Fahrenheit', value: UnitOfMeasure$1.DEGREES_F, code: '°F' },
        _a[UnitOfMeasure$1.DEGREES_C] = { name: 'Degrees Celsius', value: UnitOfMeasure$1.DEGREES_C, code: '°C' },
        _a[UnitOfMeasure$1.DEGREES_K] = { name: 'Degrees Kelvin', value: UnitOfMeasure$1.DEGREES_K, code: '°K' },
        _a[UnitOfMeasure$1.PASCAL] = { name: 'Pascal', value: UnitOfMeasure$1.PASCAL, code: 'Pa' },
        _a[UnitOfMeasure$1.HECTOPASCAL] = { name: 'Hectopascal', value: UnitOfMeasure$1.HECTOPASCAL, code: 'hPa' },
        _a[UnitOfMeasure$1.KILOPASCAL] = { name: 'Kilopascal', value: UnitOfMeasure$1.KILOPASCAL, code: 'kPa' },
        _a[UnitOfMeasure$1.MEGAPASCAL] = { name: 'Megapascal', value: UnitOfMeasure$1.MEGAPASCAL, code: 'MPa' },
        _a[UnitOfMeasure$1.GIGAPASCAL] = { name: 'Gigapascal', value: UnitOfMeasure$1.GIGAPASCAL, code: 'GPa' },
        _a[UnitOfMeasure$1.BAR] = { name: 'Bar', value: UnitOfMeasure$1.BAR, code: 'bar' },
        _a[UnitOfMeasure$1.MILLIBAR] = { name: 'Millibar', value: UnitOfMeasure$1.MILLIBAR, code: 'mbar' },
        _a[UnitOfMeasure$1.CENTIBAR] = { name: 'Centibar', value: UnitOfMeasure$1.CENTIBAR, code: 'cbar' },
        _a[UnitOfMeasure$1.DECIBAR] = { name: 'Decibar', value: UnitOfMeasure$1.DECIBAR, code: 'dbar' },
        _a[UnitOfMeasure$1.KILOBAR] = { name: 'Kilobar', value: UnitOfMeasure$1.KILOBAR, code: 'kbar' },
        _a[UnitOfMeasure$1.MEGABAR] = { name: 'Megabar', value: UnitOfMeasure$1.MEGABAR, code: 'Mbar' },
        _a[UnitOfMeasure$1.ATM] = { name: 'Standard atmosphere', value: UnitOfMeasure$1.ATM, code: 'atm' },
        _a[UnitOfMeasure$1.INCH_MERCURY] = { name: 'Inches of mercury', value: UnitOfMeasure$1.INCH_MERCURY, code: 'inHg' },
        _a[UnitOfMeasure$1.MILLIMETER_MERCURY] = { name: 'Millimeters of mercury', value: UnitOfMeasure$1.MILLIMETER_MERCURY, code: 'mmHg' },
        _a[UnitOfMeasure$1.CENTIMETER_MERCURY] = { name: 'Centimeters of mercury', value: UnitOfMeasure$1.CENTIMETER_MERCURY, code: 'cmHg' },
        _a[UnitOfMeasure$1.TORR] = { name: 'Torr', value: UnitOfMeasure$1.TORR, code: 'Torr' },
        _a[UnitOfMeasure$1.MILLITORR] = { name: 'Millitorr', value: UnitOfMeasure$1.MILLITORR, code: 'mTorr' },
        _a[UnitOfMeasure$1.INCH_WATER] = { name: 'Inches of water', value: UnitOfMeasure$1.INCH_WATER, code: 'inH₂O' },
        _a[UnitOfMeasure$1.MILLIMETER_WATER] = { name: 'Millimeters of water', value: UnitOfMeasure$1.MILLIMETER_WATER, code: 'mmH₂O' },
        _a[UnitOfMeasure$1.CENTIMETER_WATER] = { name: 'Centimeters of water', value: UnitOfMeasure$1.CENTIMETER_WATER, code: 'cmH₂O' },
        _a[UnitOfMeasure$1.POUND_SQUARE_INCH] = { name: 'Pounds per square inch', value: UnitOfMeasure$1.POUND_SQUARE_INCH, code: 'psi' },
        _a[UnitOfMeasure$1.CUBIC_FEET_PER_MINUTE] = { name: 'Cubic feet per minute', value: UnitOfMeasure$1.CUBIC_FEET_PER_MINUTE, code: 'ft³/min' },
        _a[UnitOfMeasure$1.CUBIC_FEET_PER_SECOND] = { name: 'Cubic feet per second', value: UnitOfMeasure$1.CUBIC_FEET_PER_SECOND, code: 'ft³/s' },
        _a[UnitOfMeasure$1.CUBIC_FEET_PER_HOUR] = { name: 'Cubic feet per hour', value: UnitOfMeasure$1.CUBIC_FEET_PER_HOUR, code: 'ft³/hour' },
        _a[UnitOfMeasure$1.CUBIC_METERS_PER_SECOND] = { name: 'Cubic meters per second', value: UnitOfMeasure$1.CUBIC_METERS_PER_SECOND, code: 'm³/s' },
        _a[UnitOfMeasure$1.CUBIC_METERS_PER_MINUTE] = { name: 'Cubic meters per minute', value: UnitOfMeasure$1.CUBIC_METERS_PER_MINUTE, code: 'm³/min' },
        _a[UnitOfMeasure$1.CUBIC_METERS_PER_HOUR] = { name: 'Cubic meters per hour', value: UnitOfMeasure$1.CUBIC_METERS_PER_HOUR, code: 'm³/hour' },
        _a[UnitOfMeasure$1.LITERS_PER_SECOND] = { name: 'Liters per second', value: UnitOfMeasure$1.LITERS_PER_SECOND, code: 'l/s' },
        _a[UnitOfMeasure$1.LITERS_PER_MINUTE] = { name: 'Liters per minute', value: UnitOfMeasure$1.LITERS_PER_MINUTE, code: 'l/min' },
        _a[UnitOfMeasure$1.LITERS_PER_HOUR] = { name: 'Liters per hour', value: UnitOfMeasure$1.LITERS_PER_HOUR, code: 'l/hour' },
        _a[UnitOfMeasure$1.US_GALLON_PER_SECOND] = { name: 'U.S. gallons per second', value: UnitOfMeasure$1.US_GALLON_PER_SECOND, code: 'gps' },
        _a[UnitOfMeasure$1.US_GALLON_PER_MINUTE] = { name: 'U.S. gallons per minute', value: UnitOfMeasure$1.US_GALLON_PER_MINUTE, code: 'gpm' },
        _a[UnitOfMeasure$1.US_GALLON_PER_HOUR] = { name: 'U.S. gallons per hour', value: UnitOfMeasure$1.US_GALLON_PER_HOUR, code: 'gph' },
        _a[UnitOfMeasure$1.FEET_PER_SECOND] = { name: 'Feet per second', value: UnitOfMeasure$1.FEET_PER_SECOND, code: 'ft/s' },
        _a[UnitOfMeasure$1.FEET_PER_MINUTE] = { name: 'Feet per minute', value: UnitOfMeasure$1.FEET_PER_MINUTE, code: 'ft/min' },
        _a[UnitOfMeasure$1.METERS_PER_SECOND] = { name: 'Meters per second', value: UnitOfMeasure$1.METERS_PER_SECOND, code: 'm/s' },
        _a[UnitOfMeasure$1.METERS_PER_MINUTE] = { name: 'Meters per minute', value: UnitOfMeasure$1.METERS_PER_MINUTE, code: 'm/min' },
        _a[UnitOfMeasure$1.PARTS_PER_MILLION] = { name: 'Parts per million', value: UnitOfMeasure$1.PARTS_PER_MILLION, code: 'ppm' },
        _a[UnitOfMeasure$1.PARTS_PER_BILLION] = { name: 'Parts per billion', value: UnitOfMeasure$1.PARTS_PER_BILLION, code: 'ppb' },
        _a[UnitOfMeasure$1.PARTS_PER_TRILLION] = { name: 'Parts per trillion', value: UnitOfMeasure$1.PARTS_PER_TRILLION, code: 'ppt' },
        _a[UnitOfMeasure$1.PARTS_PER_QUADRILLION] = { name: 'Parts per quadrillion', value: UnitOfMeasure$1.PARTS_PER_QUADRILLION, code: 'ppq' },
        _a[UnitOfMeasure$1.COUNT] = { name: 'Count', value: UnitOfMeasure$1.COUNT, code: '#' },
        _a[UnitOfMeasure$1.COUNT_PER_CUBIC_CENTIMETER] = { name: 'Count per cubic centimeter', value: UnitOfMeasure$1.COUNT_PER_CUBIC_CENTIMETER, code: '#/cm³' },
        _a[UnitOfMeasure$1.COUNT_PER_CUBIC_METER] = { name: 'Count per cubic meter', value: UnitOfMeasure$1.COUNT_PER_CUBIC_METER, code: '#/m³' },
        _a[UnitOfMeasure$1.COUNT_PER_CUBIC_FOOT] = { name: 'Count per cubic foot', value: UnitOfMeasure$1.COUNT_PER_CUBIC_FOOT, code: '#/ft³' },
        _a[UnitOfMeasure$1.COUNT_PER_DECILITER] = { name: 'Count per deciliter', value: UnitOfMeasure$1.COUNT_PER_DECILITER, code: '#/dL' },
        _a[UnitOfMeasure$1.COUNT_PER_LITER] = { name: 'Count per liter', value: UnitOfMeasure$1.COUNT_PER_LITER, code: '#/L' },
        _a[UnitOfMeasure$1.MILLIGRAMS_PER_CUBIC_METER] = { name: 'Milligrams per cubic meter', value: UnitOfMeasure$1.MILLIGRAMS_PER_CUBIC_METER, code: 'mg/m³' },
        _a[UnitOfMeasure$1.KILOGRAMS_PER_CUBIC_METER] = { name: 'Kilograms per cubic meter', value: UnitOfMeasure$1.KILOGRAMS_PER_CUBIC_METER, code: 'kg/m³' },
        _a[UnitOfMeasure$1.MICROGRAMS_PER_CUBIC_METER] = { name: 'Micrograms per cubic meter', value: UnitOfMeasure$1.MICROGRAMS_PER_CUBIC_METER, code: 'µg/m³' },
        _a[UnitOfMeasure$1.KILOGRAMS_PER_LITER] = { name: 'Kilograms per liter', value: UnitOfMeasure$1.KILOGRAMS_PER_LITER, code: 'kg/l' },
        _a[UnitOfMeasure$1.GRAMS_PER_MILLILITER] = { name: 'grams per milliliter', value: UnitOfMeasure$1.GRAMS_PER_MILLILITER, code: 'g/ml' },
        _a[UnitOfMeasure$1.METRIC_TON_PER_CUBIC_METER] = { name: 'Metric ton per cubic meter', value: UnitOfMeasure$1.METRIC_TON_PER_CUBIC_METER, code: 't/m³' },
        _a[UnitOfMeasure$1.GRAMS_PER_CUBIC_CENTIMETER] = { name: 'Grams per cubic centimeter', value: UnitOfMeasure$1.GRAMS_PER_CUBIC_CENTIMETER, code: 'g/cm³' },
        _a[UnitOfMeasure$1.PARTICLE_SIZE] = { name: 'Particle Size', value: UnitOfMeasure$1.PARTICLE_SIZE, code: '' },
        _a[UnitOfMeasure$1.SPECTRUM] = { name: 'Spectrum', value: UnitOfMeasure$1.SPECTRUM, code: '' },
        _a[UnitOfMeasure$1.MILLIVOLT] = { name: 'Millivolt', value: UnitOfMeasure$1.MILLIVOLT, code: 'mV' },
        _a[UnitOfMeasure$1.VOLT] = { name: 'Volt', value: UnitOfMeasure$1.VOLT, code: 'V' },
        _a[UnitOfMeasure$1.KILOVOLT] = { name: 'Kilovolt', value: UnitOfMeasure$1.KILOVOLT, code: 'kV' },
        _a[UnitOfMeasure$1.MILLIAMP] = { name: 'Milliamp', value: UnitOfMeasure$1.MILLIAMP, code: 'mA' },
        _a[UnitOfMeasure$1.AMP] = { name: 'Amp', value: UnitOfMeasure$1.AMP, code: 'A' },
        _a[UnitOfMeasure$1.KILOAMP] = { name: 'KiloAmp', value: UnitOfMeasure$1.KILOAMP, code: 'kA' },
        _a[UnitOfMeasure$1.NANOMETER] = { name: 'Nanometer', value: UnitOfMeasure$1.NANOMETER, code: 'nm' },
        _a[UnitOfMeasure$1.MICROMETER] = { name: 'Micrometer', value: UnitOfMeasure$1.MICROMETER, code: 'µm' },
        _a[UnitOfMeasure$1.MILLIMETER] = { name: 'Millimeter', value: UnitOfMeasure$1.MILLIMETER, code: 'mm' },
        _a[UnitOfMeasure$1.CENTIMETER] = { name: 'Centimeter', value: UnitOfMeasure$1.CENTIMETER, code: 'cm' },
        _a[UnitOfMeasure$1.METER] = { name: 'Meter', value: UnitOfMeasure$1.METER, code: 'm' },
        _a[UnitOfMeasure$1.KILOMETER] = { name: 'Kilometer', value: UnitOfMeasure$1.KILOMETER, code: 'km' },
        _a[UnitOfMeasure$1.NANOSECOND] = { name: 'Nanosecond', value: UnitOfMeasure$1.NANOSECOND, code: 'ns' },
        _a[UnitOfMeasure$1.MILLISECOND] = { name: 'Millisecond', value: UnitOfMeasure$1.MILLISECOND, code: 'ms' },
        _a[UnitOfMeasure$1.SECOND] = { name: 'Second', value: UnitOfMeasure$1.SECOND, code: 's' },
        _a[UnitOfMeasure$1.LITER] = { name: 'Liter', value: UnitOfMeasure$1.LITER, code: 'L' },
        _a[UnitOfMeasure$1.MILLILITER] = { name: 'Milliliter', value: UnitOfMeasure$1.MILLILITER, code: 'mL' },
        _a[UnitOfMeasure$1.CUBIC_FEET] = { name: 'Cubic feet', value: UnitOfMeasure$1.CUBIC_FEET, code: 'ft³' },
        _a[UnitOfMeasure$1.RELATIVE_HUMIDITY] = { name: 'Relative humidity', value: UnitOfMeasure$1.RELATIVE_HUMIDITY, code: 'RH' },
        _a[UnitOfMeasure$1.RELATIVE_HUMIDITY_PERCENT] = { name: 'Relative humidity', value: UnitOfMeasure$1.RELATIVE_HUMIDITY_PERCENT, code: '%RH' },
        _a[UnitOfMeasure$1.DECIBELS] = { name: 'Decibels', value: UnitOfMeasure$1.DECIBELS, code: 'dB' },
        _a));

    var MeasurementTypes = Object.freeze({
        nh3_ppm: {
            aliases: ['nh3_ppm', 'Ammonia', 'Ammonia (ppm)', 'Ammonia (Parts per million)'],
            name: 'nh3_ppm'
        },
        nh3_mgm3: {
            aliases: ['nh3_mgm3', 'Ammonia Mass Concentration', 'Ammonia (mg/m³)', 'Ammonia (Milligrams per cubic meter)'],
            name: 'nh3_mgm3'
        },
        baro_inhg: {
            aliases: ['Barometric Pressure', 'BP', 'baro_inhg'],
            name: 'baro_inhg'
        },
        Date: {
            aliases: ['Date'],
            name: 'Date'
        },
        DateTime: {
            aliases: ['Date/Time', 'datetime'],
            name: 'DateTime'
        },
        dewpoint: {
            aliases: ['Dew Point', 'dewpoint'],
            name: 'dewpoint'
        },
        mcpm1x0: {
            aliases: ['PM 1.0', 'PM1', 'pm1', 'PM1_Concentration', 'mcpm1x0', 'PM1.0', 'mcbinpm1x0'],
            name: 'mcpm1x0'
        },
        mcpm2x5: {
            aliases: ['PM 2.5', 'pm2.5', 'PM2.5', 'PM2p5_Concentration', 'Concentration', 'mcpm2x5', 'mcbinpm2x5'],
            name: 'mcpm2x5'
        },
        mcpm4x0: {
            aliases: ['PM 4.0', 'PM4', 'pm4.0', 'PM4.0', 'mcpm4x0', 'RESP', 'mcbinpm4x0'],
            name: 'mcpm4x0'
        },
        mcpm10: {
            aliases: ['PM 10', 'PM10', 'PM10.0', 'PM 10.0', 'PM10_Concentration', 'mcpm10', 'pm10', 'mcbinpm10'],
            name: 'mcpm10'
        },
        mcpm1x0_min: {
            aliases: ['mcpm1x0_min'],
            name: 'mcpm1x0_min'
        },
        mcpm1x0_max: {
            aliases: ['mcpm1x0_max'],
            name: 'mcpm1x0_max'
        },
        mcpm1x0_avg: {
            aliases: ['mcpm1x0_avg'],
            name: 'mcpm1x0_avg'
        },
        mcpm1x0_twa: {
            aliases: ['mcpm1x0_twa'],
            name: 'mcpm1x0_twa'
        },
        mcpm2x5_min: {
            aliases: ['mcpm2x5_min'],
            name: 'mcpm2x5_min'
        },
        mcpm2x5_max: {
            aliases: ['mcpm2x5_max'],
            name: 'mcpm2x5_max'
        },
        mcpm2x5_avg: {
            aliases: ['mcpm2x5_avg'],
            name: 'mcpm2x5_avg'
        },
        mcpm2x5_twa: {
            aliases: ['mcpm2x5_twa'],
            name: 'mcpm2x5_twa'
        },
        mcpm4x0_min: {
            aliases: ['mcpm4x0_min'],
            name: 'mcpm4x0_min'
        },
        mcpm4x0_max: {
            aliases: ['mcpm4x0_max'],
            name: 'mcpm4x0_max'
        },
        mcpm4x0_avg: {
            aliases: ['mcpm4x0_avg'],
            name: 'mcpm4x0_avg'
        },
        mcpm4x0_twa: {
            aliases: ['mcpm4x0_twa'],
            name: 'mcpm4x0_twa'
        },
        mcpm10_min: {
            aliases: ['mcpm10_min'],
            name: 'mcpm10_min'
        },
        mcpm10_max: {
            aliases: ['mcpm10_max'],
            name: 'mcpm10_max'
        },
        mcpm10_avg: {
            aliases: ['mcpm10_avg'],
            name: 'mcpm10_avg'
        },
        mcpm10_twa: {
            aliases: ['mcpm10_twa'],
            name: 'mcpm10_twa'
        },
        mcpm_total: {
            aliases: ['mcpm_total', 'TOTAL', 'Mass', 'AEROSOL'],
            name: 'mcpm_total'
        },
        mcpm_total_min: {
            aliases: ['mcpm_total_min'],
            name: 'mcpm_total_min'
        },
        mcpm_total_max: {
            aliases: ['mcpm_total_max'],
            name: 'mcpm_total_max'
        },
        mcpm_total_avg: {
            aliases: ['mcpm_total_avg'],
            name: 'mcpm_total_avg'
        },
        mcpm_total_twa: {
            aliases: ['mcpm_total_twa'],
            name: 'mcpm_total_twa'
        },
        ncpm0x3: {
            aliases: ['Particle Conc. 0.3', 'CountsPM_0p3um', 'numberCount_0.3', 'Ch1 Cumul', 'Particle Concentration 0.3', 'ncpm0x3', 'ncbinpm0x3'],
            name: 'ncpm0x3'
        },
        ncpm0x5: {
            aliases: ['PN 0.3-0.5µm', 'Particle Conc. 0.5', 'CountsPM_0p5um', 'numberCount_0.5', 'Ch2 Cumul', 'ncpm0x5', 'NC 0.3-0.5µm', 'Particle Concentration 0.5', 'NC0.5', 'ncbinpm0x5'],
            name: 'ncpm0x5'
        },
        ncpm1x0: {
            aliases: ['PN 0.5-1.0µm', 'Particle Conc. 1.0', 'CountsPM_1um', 'numberCount_1', 'Ch3 Cumul', 'ncpm1x0', 'NC 0.5-1.0µm', 'Particle Concentration 1.0', 'NC1.0', 'ncbinpm1x0'],
            name: 'ncpm1x0'
        },
        ncpm2x5: {
            aliases: ['PN 1.0-2.5µm', 'Particle Conc. 2.5', 'CountsPM_2p5um', 'ncpm2x5', 'NC 1.0-2.5µm', 'numberCount_2.5', 'Particle Concentration 2.5', 'NC2.5', 'ncbinpm2x5'],
            name: 'ncpm2x5'
        },
        ncpm4x0: {
            aliases: ['PN 2.5-4.0µm', 'ncpm4x0', 'numberCount_4', 'NC 2.5-4.0µm', 'NC4', 'ncbinpm4x0'],
            name: 'ncpm4x0'
        },
        ncpm5x0: {
            aliases: ['ncpm5x0', 'Particle Conc. 5.0', 'CountsPM_5um', 'numberCount_5', 'Ch4 Cumul', 'Particle Concentration 5.0'],
            name: 'ncpm5x0'
        },
        ncpm10: {
            aliases: ['PN 4.0-10µm', 'Particle Conc. 10.0', 'CountsPM_10um', 'numberCount_10', 'Ch5 Cumul', 'Particle Concentration 10.0', 'ncpm10', 'NC 4.0-10.0µm', 'NC 4.0-10µm', 'NC10'],
            name: 'ncpm10'
        },
        rh_percent: {
            aliases: ['H', 'Relative Humidity', 'rh_percent'],
            name: 'rh_percent'
        },
        temp_c: {
            aliases: ['T', 'Temperature', 'temp_c'],
            name: 'temp_c'
        },
        Time: {
            aliases: ['Time', 'Duration (min)'],
            name: 'Time'
        },
        voc_ppm: {
            aliases: ['Total VOC Low (Parts per million)', 'TVOC', 'tvoc (PARTS_PER_MILLION)', 'voc_ppm', 'tvoc_ppm', 'VOC High', 'VOC High (ppm)', 'VOC_High'],
            name: 'voc_ppm'
        },
        voc_ppb: {
            aliases: ['gas_voc', 'VOC', 'Total VOC Low (Parts per billion)', 'tvoc (PARTS_PER_BILLION)', 'voc_ppb', 'tvoc_ppb', 'qt_gas', 'VOC Low', 'VOC Low (ppb)'],
            name: 'voc_ppb'
        },
        voc_ugm3: {
            aliases: ['tvoc (MICROGRAMS_PER_CUBIC_METER)'],
            name: 'voc_ugm3'
        },
        voc_mgm3: {
            aliases: ['Total VOC Low (Milligrams per cubic meter)', 'tvoc (MILLIGRAMS_PER_CUBIC_METER)'],
            name: 'voc_mgm3'
        },
        wetbulb: {
            aliases: ['Wet Bulb', 'wetbulb'],
            name: 'wetbulb'
        },
        TVOCErrorStatus: {
            aliases: ['TVOC Sensor Error Status', 'tvocStatus', 'VOC High Sensor Error Status', 'VOC Low Sensor Error Status'],
            name: 'TVOCErrorStatus'
        },
        PMErrorStatus: {
            aliases: ['PM Sensor Error Status'],
            name: 'PMErrorStatus'
        },
        ch2o_ppb: {
            aliases: ['ch2o_ppb', 'Formaldehyde (Parts per billion)', 'Formaldehyde (ppb)'],
            name: 'ch2o_ppb'
        },
        ch2o_inhg: {
            aliases: ['ch2o_inhg'],
            name: 'ch2o_inhg'
        },
        ch2o_ppm: {
            aliases: ['ch2o_ppm', 'Formaldehyde', 'CH2O', 'Formaldehyde (Parts per million)', 'Formaldehyde (ppm)'],
            name: 'ch2o_ppm'
        },
        ch2o_mgm3: {
            aliases: ['ch2o_mgm3', 'Formaldehyde Mass Concentration', 'Formaldehyde (Milligrams per cubic meter)'],
            name: 'ch2o_mgm3'
        },
        so2_ppb: {
            aliases: ['so2_ppb'],
            name: 'so2_ppb'
        },
        no2_ppm: {
            aliases: ['no2_ppm', 'Nitrogen Dioxide (ppm)', 'Nitrogen Dioxide (Parts per million)'],
            name: 'no2_ppm'
        },
        no2_ppb: {
            aliases: ['no2_ppb'],
            name: 'no2_ppb'
        },
        no2_mgm3: {
            aliases: ['no2_mgm3', 'Nitrogen Dioxide (mg/m³)', 'Nitrogen Dioxide (Milligrams per cubic meter)'],
            name: 'no2_mgm3'
        },
        co2_ppm: {
            aliases: ['CO2', 'co2_ppm', 'Carbon Dioxide', 'Carbon Dioxide (ppm)', 'Carbon Dioxide (Parts per million)'],
            name: 'co2_ppm'
        },
        co2_mgm3: {
            aliases: ['co2_mgm3', 'Carbon Dioxide Mass Concentration', 'Carbon Dioxide (mg/m³)', 'Carbon Dioxide (Milligrams per cubic meter)'],
            name: 'co2_mgm3'
        },
        co_ppm: {
            aliases: ['co_ppm', 'Carbon Monoxide', 'CO', 'Carbon Monoxide (ppm)', 'Carbon Monoxide (Parts per million)'],
            name: 'co_ppm'
        },
        co_mgm3: {
            aliases: ['co_mgm3', 'Carbon Monoxide Mass Concentration', 'Carbon Monoxide (mg/m³)', 'Carbon Monoxide (Milligrams per cubic meter)'],
            name: 'co_mgm3'
        },
        o3_ppb: {
            aliases: ['o3_ppb', 'Ozone (O3)', 'Ozone (Parts per billion)'],
            name: 'o3_ppb'
        },
        o3_ppm: {
            aliases: ['o3_ppm', 'Ozone', 'Ozone (Parts per million)', 'Ozone (ppm)'],
            name: 'o3_ppm'
        },
        o3_mgm3: {
            aliases: ['o3_mgm3', 'Ozone (Milligrams per cubic meter)'],
            name: 'o3_mgm3'
        },
        cl_ppm: {
            aliases: ['cl_ppm', 'Chlorine (Parts per million)', 'Chlorine (ppm)'],
            name: 'cl_ppm'
        },
        cl_mgm3: {
            aliases: ['cl_mgm3', 'Chlorine (Milligrams per cubic meter)'],
            name: 'cl_mgm3'
        },
        cl2_ppm: {
            aliases: ['cl2_ppm', 'Chlorine'],
            name: 'cl2_ppm'
        },
        h2s_ppm: {
            aliases: ['h2s_ppm', 'Hydrogen Sulfide'],
            name: 'h2s_ppm'
        },
        no_ppm: {
            aliases: ['no_ppm', 'Nitric Oxide'],
            name: 'no_ppm'
        },
        lzs_max: {
            aliases: ['lzs_max', 'Broadband-LZSmax', 'LZSmax'],
            name: 'lzs_max'
        },
        lzf_max: {
            aliases: ['lzf_max', 'Broadband-LZFmax', 'LZFmax'],
            name: 'lzf_max'
        },
        lzi_max: {
            aliases: ['lzi_max', 'Broadband-LZImax', 'LZImax'],
            name: 'lzi_max'
        },
        lzs_min: {
            aliases: ['lzs_min', 'Broadband-LZSmin', 'LZSmin'],
            name: 'lzs_min'
        },
        lzf_min: {
            aliases: ['lzf_min', 'Broadband-LZFmin', 'LZFmin'],
            name: 'lzf_min'
        },
        lzi_min: {
            aliases: ['lzi_min', 'Broadband-LZImin', 'LZImin'],
            name: 'lzi_min'
        },
        lzeq: {
            aliases: ['lzeq', 'Broadband-LZeq', 'LZEQ'],
            name: 'lzeq'
        },
        lzpeak: {
            aliases: ['lzpeak', 'Broadband-LZpeak', 'LZPk'],
            name: 'lzpeak'
        },
        lcs_max: {
            aliases: ['lcs_max', 'Broadband-LCSmax', 'LCSmax'],
            name: 'lcs_max'
        },
        lcf_max: {
            aliases: ['lcf_max', 'Broadband-LCFmax', 'LCFmax'],
            name: 'lcf_max'
        },
        lci_max: {
            aliases: ['lci_max', 'Broadband-LCImax', 'LCImax'],
            name: 'lci_max'
        },
        lcs_min: {
            aliases: ['lcs_min', 'Broadband-LCSmin', 'LCSmin'],
            name: 'lcs_min'
        },
        lcf_min: {
            aliases: ['lcf_min', 'Broadband-LCFmin', 'LCFmin'],
            name: 'lcf_min'
        },
        lci_min: {
            aliases: ['lci_min', 'Broadband-LCImin', 'LCImin'],
            name: 'lci_min'
        },
        lceq: {
            aliases: ['lceq', 'Broadband-LCeq', 'LCEQ'],
            name: 'lceq'
        },
        lcpeak: {
            aliases: ['lcpeak', 'Broadband-LCpeak', 'LCPk'],
            name: 'lcpeak'
        },
        las_max: {
            aliases: ['las_max', 'Broadband-LASmax', 'LASmax'],
            name: 'las_max'
        },
        laf_max: {
            aliases: ['laf_max', 'Broadband-LAFmax', 'LAFmax'],
            name: 'laf_max'
        },
        lai_max: {
            aliases: ['lai_max', 'Broadband-LAImax', 'LAImax'],
            name: 'lai_max'
        },
        las_min: {
            aliases: ['las_min', 'Broadband-LASmin', 'LASmin'],
            name: 'las_min'
        },
        laf_min: {
            aliases: ['laf_min', 'Broadband-LAFmin', 'LAFmin'],
            name: 'laf_min'
        },
        lai_min: {
            aliases: ['lai_min', 'Broadband-LAImin', 'LAImin'],
            name: 'lai_min'
        },
        laeq: {
            aliases: ['laeq', 'Broadband-LAeq', 'LAEQ'],
            name: 'laeq'
        },
        lapeak: {
            aliases: ['lapeak', 'Broadband-LApeak', 'LAPk'],
            name: 'lapeak'
        },
        lzf_max_16: {
            aliases: ['lzf_max_16', 'Octave LZFmax-16Hz'],
            name: 'lzf_max_16'
        },
        lzf_max_32: {
            aliases: ['lzf_max_32', 'Octave LZFmax-31.5Hz'],
            name: 'lzf_max_32'
        },
        lzf_max_64: {
            aliases: ['lzf_max_64', 'Octave LZFmax-64Hz'],
            name: 'lzf_max_64'
        },
        lzf_max_125: {
            aliases: ['lzf_max_125', 'Octave LZFmax-125Hz'],
            name: 'lzf_max_125'
        },
        lzf_max_250: {
            aliases: ['lzf_max_250', 'Octave LZFmax-250Hz'],
            name: 'lzf_max_250'
        },
        lzf_max_500: {
            aliases: ['lzf_max_500', 'Octave LZFmax-500Hz'],
            name: 'lzf_max_500'
        },
        lzf_max_1K: {
            aliases: ['lzf_max_1K', 'Octave LZFmax-1KHz'],
            name: 'lzf_max_1K'
        },
        lzf_max_2K: {
            aliases: ['lzf_max_2K', 'Octave LZFmax-2KHz'],
            name: 'lzf_max_2K'
        },
        lzf_max_4K: {
            aliases: ['lzf_max_4K', 'Octave LZFmax-4KHz'],
            name: 'lzf_max_4K'
        },
        lzf_max_8K: {
            aliases: ['lzf_max_8K', 'Octave LZFmax-8KHz'],
            name: 'lzf_max_8K'
        },
        lzf_max_16K: {
            aliases: ['lzf_max_16K', 'Octave LZFmax-16KHz'],
            name: 'lzf_max_16K'
        },
        lzs_max_16: {
            aliases: ['lzs_max_16', 'Octave LZSmax-16Hz'],
            name: 'lzs_max_16'
        },
        lzs_max_32: {
            aliases: ['lzs_max_32', 'Octave LZSmax-31.5Hz'],
            name: 'lzs_max_32'
        },
        lzs_max_64: {
            aliases: ['lzs_max_64', 'Octave LZSmax-64Hz'],
            name: 'lzs_max_64'
        },
        lzs_max_125: {
            aliases: ['lzs_max_125', 'Octave LZSmax-125Hz'],
            name: 'lzs_max_125'
        },
        lzs_max_250: {
            aliases: ['lzs_max_250', 'Octave LZSmax-250Hz'],
            name: 'lzs_max_250'
        },
        lzs_max_500: {
            aliases: ['lzs_max_500', 'Octave LZSmax-500Hz'],
            name: 'lzs_max_500'
        },
        lzs_max_1K: {
            aliases: ['lzs_max_1K', 'Octave LZSmax-1KHz'],
            name: 'lzs_max_1K'
        },
        lzs_max_2K: {
            aliases: ['lzs_max_2K', 'Octave LZSmax-2KHz'],
            name: 'lzs_max_2K'
        },
        lzs_max_4K: {
            aliases: ['lzs_max_4K', 'Octave LZSmax-4KHz'],
            name: 'lzs_max_4K'
        },
        lzs_max_8K: {
            aliases: ['lzs_max_8K', 'Octave LZSmax-8KHz'],
            name: 'lzs_max_8K'
        },
        lzs_max_16K: {
            aliases: ['lzs_max_16K', 'Octave LZSmax-16KHz'],
            name: 'lzs_max_16K'
        },
        lzeq_16: {
            aliases: ['lzeq_16', 'Octave LZeq-16Hz'],
            name: 'lzeq_16'
        },
        lzeq_32: {
            aliases: ['lzeq_32', 'Octave LZeq-31.5Hz'],
            name: 'lzeq_32'
        },
        lzeq_64: {
            aliases: ['lzeq_64', 'Octave LZeq-64Hz'],
            name: 'lzeq_64'
        },
        lzeq_125: {
            aliases: ['lzeq_125', 'Octave LZeq-125Hz'],
            name: 'lzeq_125'
        },
        lzeq_250: {
            aliases: ['lzeq_250', 'Octave LZeq-250Hz'],
            name: 'lzeq_250'
        },
        lzeq_500: {
            aliases: ['lzeq_500', 'Octave LZeq-500Hz'],
            name: 'lzeq_500'
        },
        lzeq_1K: {
            aliases: ['lzeq_1K', 'Octave LZeq-1KHz'],
            name: 'lzeq_1K'
        },
        lzeq_2K: {
            aliases: ['lzeq_2K', 'Octave LZeq-2KHz'],
            name: 'lzeq_2K'
        },
        lzeq_4K: {
            aliases: ['lzeq_4K', 'Octave LZeq-4KHz'],
            name: 'lzeq_4K'
        },
        lzeq_8K: {
            aliases: ['lzeq_8K', 'Octave LZeq-8KHz'],
            name: 'lzeq_8K'
        },
        lzeq_16K: {
            aliases: ['lzeq_16K', 'Octave LZeq-16KHz'],
            name: 'lzeq_16K'
        },
        lzs: {
            aliases: ['lzs', 'LZS'],
            name: 'lzs'
        },
        lzf: {
            aliases: ['lzf', 'LZF'],
            name: 'lzf'
        },
        lzi: {
            aliases: ['lzi', 'LZI'],
            name: 'lzi'
        },
        lcs: {
            aliases: ['lcs', 'LCS'],
            name: 'lcs'
        },
        lcf: {
            aliases: ['lcf', 'LCF'],
            name: 'lcf'
        },
        lci: {
            aliases: ['lci', 'LCI'],
            name: 'lci'
        },
        las: {
            aliases: ['las', 'LAS'],
            name: 'las'
        },
        laf: {
            aliases: ['laf', 'LAF'],
            name: 'laf'
        },
        lai: {
            aliases: ['lai', 'LAI'],
            name: 'lai'
        },
        laieq: {
            aliases: ['laieq', 'LAIEQ'],
            name: 'laieq'
        },
        lae: {
            aliases: ['lae', 'LAE'],
            name: 'lae'
        },
        laeq_t80: {
            aliases: ['laeq_t80', 'LAEQT80'],
            name: 'laeq_t80'
        },
        laft_m3: {
            aliases: ['laft_m3', 'LAFTm3'],
            name: 'laft_m3'
        },
        laft_m5: {
            aliases: ['laft_m5', 'LAFTm5'],
            name: 'laft_m5'
        },
        lait_m3: {
            aliases: ['lait_m3', 'LAITm3'],
            name: 'lait_m3'
        },
        lait_m5: {
            aliases: ['lait_m5', 'LAITm5'],
            name: 'lait_m5'
        },
        lavg_1_t1nn_q1n: {
            aliases: ['lavg_1_t1nn_q1n'],
            name: 'lavg_1_t1nn_q1n'
        },
        lavg_2_t2nn_q2n: {
            aliases: ['lavg_2_t2nn_q2n'],
            name: 'lavg_2_t2nn_q2n'
        },
        lceq_laeq: {
            aliases: ['lceq_laeq', 'LCEQ - LAEQ'],
            name: 'lceq_laeq'
        },
        lex_8hr: {
            aliases: ['lex_8hr', 'LEX, 8Hr'],
            name: 'lex_8hr'
        },
        lep_d: {
            aliases: ['lep_d', 'LEP,d'],
            name: 'lep_d'
        },
        proj_lex_8hr: {
            aliases: ['proj_lex_8hr', 'Proj. LEX, 8hr'],
            name: 'proj_lex_8hr'
        },
        proj_lep_d: {
            aliases: ['proj_lep_d', 'Proj. LEP,d'],
            name: 'proj_lep_d'
        },
        twa_8hr: {
            aliases: ['twa_8hr', 'TWA (8hr)'],
            name: 'twa_8hr'
        },
        proj_twa_8hr: {
            aliases: ['proj_twa_8hr', 'Projected TWA (8hr)'],
            name: 'proj_twa_8hr'
        },
        dose_percent: {
            aliases: ['dose_percent', 'Dose %'],
            name: 'dose_percent'
        },
        proj_dose_percent: {
            aliases: ['proj_dose_percent', 'Projected Dose %'],
            name: 'proj_dose_percent'
        },
        abs_pressure: {
            aliases: ['abs_pressure'],
            name: 'abs_pressure'
        }
    });
    var ParamMeasurementTypes = Object.freeze({
        lavg_1_t1nn_q1n: {
            aliases: ['LAVG 1 \\((T=\\d+, Q=\\d+)\\)'],
            name: 'lavg_1_t1nn_q1n',
        },
        lavg_2_t2nn_q2n: {
            aliases: ['LAVG 2 \\((T=\\d+, Q=\\d+)\\)'],
            name: 'lavg_2_t2nn_q2n'
        },
        proj_twa_8hr: {
            aliases: ['^Proj\\. TWA \\((T=\\d+, Q=\\d+)\\)$'],
            name: 'proj_twa_8hr'
        },
        proj_dose_percent: {
            aliases: ['^Proj\\. Dose % \\((C=\\d+)\\)$'],
            name: 'proj_dose_percent'
        },
        dose_percent: {
            aliases: ['^Dose % \\((C=\\d+)\\)$'],
            name: 'dose_percent'
        },
        twa_8hr: {
            aliases: ['^TWA \\((T=\\d+, Q=\\d+)\\)$'],
            name: 'twa_8hr'
        },
    });

    function setPrecision(value, numDecimals) {
        var isNegative = (value < 0);
        var multiplier = Math.pow(10, numDecimals);
        var result = Math.round(Math.abs(value) * multiplier) / multiplier;
        if (numDecimals <= 0) {
            result = Math.round(result);
        }
        if (isNegative && result !== 0) {
            result = -result;
        }
        return result;
    }

    var Temperature;
    (function (Temperature) {
        var F_MOD = 1.8;
        var K_MOD = 273.15;
        var THIRTY_TWO = 32.0;
        var CtoF = (function () {
            function CtoF() {
            }
            CtoF.getFrom = function () {
                return UnitOfMeasure$1.DEGREES_C;
            };
            CtoF.getTo = function () {
                return UnitOfMeasure$1.DEGREES_F;
            };
            CtoF.convert = function (value, precision) {
                var exactVal = (value * F_MOD) + THIRTY_TWO;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            CtoF.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return CtoF;
        }());
        Temperature.CtoF = CtoF;
        var CtoK = (function () {
            function CtoK() {
            }
            CtoK.getFrom = function () {
                return UnitOfMeasure$1.DEGREES_C;
            };
            CtoK.getTo = function () {
                return UnitOfMeasure$1.DEGREES_K;
            };
            CtoK.convert = function (value, precision) {
                var exactVal = value + K_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            CtoK.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return CtoK;
        }());
        Temperature.CtoK = CtoK;
        var FtoC = (function () {
            function FtoC() {
            }
            FtoC.getFrom = function () {
                return UnitOfMeasure$1.DEGREES_F;
            };
            FtoC.getTo = function () {
                return UnitOfMeasure$1.DEGREES_C;
            };
            FtoC.convert = function (value, precision) {
                var exactVal = (value - THIRTY_TWO) / F_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            FtoC.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return FtoC;
        }());
        Temperature.FtoC = FtoC;
        var FtoK = (function () {
            function FtoK() {
            }
            FtoK.getFrom = function () {
                return UnitOfMeasure$1.DEGREES_F;
            };
            FtoK.getTo = function () {
                return UnitOfMeasure$1.DEGREES_K;
            };
            FtoK.convert = function (value, precision) {
                var exactVal = ((value - THIRTY_TWO) / F_MOD) + K_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    var final = setPrecision(exactVal, precision);
                    return final;
                }
            };
            FtoK.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return FtoK;
        }());
        Temperature.FtoK = FtoK;
        var KtoF = (function () {
            function KtoF() {
            }
            KtoF.getFrom = function () {
                return UnitOfMeasure$1.DEGREES_K;
            };
            KtoF.getTo = function () {
                return UnitOfMeasure$1.DEGREES_F;
            };
            KtoF.convert = function (value, precision) {
                var exactVal = ((value - K_MOD) * F_MOD) + THIRTY_TWO;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            KtoF.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return KtoF;
        }());
        Temperature.KtoF = KtoF;
        var KtoC = (function () {
            function KtoC() {
            }
            KtoC.getFrom = function () {
                return UnitOfMeasure$1.DEGREES_K;
            };
            KtoC.getTo = function () {
                return UnitOfMeasure$1.DEGREES_C;
            };
            KtoC.convert = function (value, precision) {
                var exactVal = value - K_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            KtoC.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return KtoC;
        }());
        Temperature.KtoC = KtoC;
    })(Temperature || (Temperature = {}));

    var Pressure;
    (function (Pressure) {
        var kPa_to_hPa = 10;
        var kPa_to_P = 1000;
        var kPa_to_mBar = 10;
        var kPa_to_cmH2O = 10.1974428892;
        var kPa_to_inH2O = 4.01865;
        var kPa_to_mmHg = 7.5006375541921;
        var kPa_to_cmHg = 0.75006375541921;
        var kPa_to_inHg = 0.2952998751;
        var kPa_to_PSI = 0.14503773773022;
        var hPa_to_kPa = 0.1;
        var hPa_to_P = 100;
        var hPa_to_mBar = 1;
        var hPa_to_cmH2O = 1.01974428892;
        var hPa_to_inH2O = 0.401865;
        var hPa_to_mmHg = 0.75006375541921;
        var hPa_to_cmHg = 0.075006375541921;
        var hPa_to_inHg = 0.02952998751;
        var hPa_to_PSI = 0.014503773773022;
        var P_to_kPa = 0.001;
        var P_to_hPa = 0.01;
        var P_to_mBar = 0.01;
        var P_to_cmH2O = 0.0101974428892;
        var P_to_inH2O = 0.00401865;
        var P_to_mmHg = 0.0075006375541921;
        var P_to_cmHg = 0.00075006375541921;
        var P_to_inHg = 0.0002952998751;
        var P_to_PSI = 0.00014503773773022;
        var mBar_to_kPa = 0.1;
        var mBar_to_hPa = 1;
        var mBar_to_P = 100;
        var mBar_to_cmH2O = 1.01974428892;
        var mBar_to_inH2O = 0.401865;
        var mBar_to_mmHg = 0.75006375541921;
        var mBar_to_cmHg = 0.075006375541921;
        var mBar_to_inHg = 0.02952998751;
        var mBar_to_PSI = 0.014503773773022;
        var cmH2O_to_kPa = 0.09806613580198487;
        var cmH2O_to_hPa = 0.9806613580198486;
        var cmH2O_to_P = 98.06613580198486;
        var cmH2O_to_mBar = 0.9806613580198486;
        var cmH2O_to_inH2O = 0.3940934766406464;
        var cmH2O_to_mmHg = 0.73555854099087;
        var cmH2O_to_cmHg = 0.073553888590369;
        var cmH2O_to_inHg = 0.028958220688763;
        var cmH2O_to_PSI = 0.014223290484664416;
        var inH2O_to_kPa = 0.249088875;
        var inH2O_to_hPa = 2.49088875;
        var inH2O_to_P = 249.088875;
        var inH2O_to_mBar = 2.49088875;
        var inH2O_to_cmH2O = 2.53746;
        var inH2O_to_mmHg = 1.86645;
        var inH2O_to_cmHg = 0.186645;
        var inH2O_to_inHg = 0.0735559124636824;
        var inH2O_to_PSI = 0.0360912;
        var mmHg_to_kPa = 0.133322;
        var mmHg_to_hPa = 1.33322;
        var mmHg_to_P = 133.322;
        var mmHg_to_mBar = 1.33322;
        var mmHg_to_cmH2O = 1.35951;
        var mmHg_to_inH2O = 0.535776474055024;
        var mmHg_to_cmHg = 0.1;
        var mmHg_to_inHg = 0.0393700791974456;
        var mmHg_to_PSI = 0.0193368;
        var cmHg_to_kPa = 1.33322;
        var cmHg_to_hPa = 13.3322;
        var cmHg_to_P = 1333.22;
        var cmHg_to_mBar = 13.3322;
        var cmHg_to_cmH2O = 13.5951;
        var cmHg_to_inH2O = 5.35776474055024;
        var cmHg_to_mmHg = 10;
        var cmHg_to_inHg = 0.393700791974456;
        var cmHg_to_PSI = 0.193368;
        var inHg_to_kPa = 3.3863886666667;
        var inHg_to_hPa = 33.863886666667;
        var inHg_to_P = 3386.3886666667;
        var inHg_to_mBar = 33.863886666667;
        var inHg_to_cmH2O = 34.531554268447;
        var inHg_to_inH2O = 13.595100196653;
        var inHg_to_mmHg = 25.399999704976;
        var inHg_to_cmHg = 2.5399999704976;
        var inHg_to_PSI = 0.49115415222661;
        var PSI_to_kPa = 6.89476;
        var PSI_to_hPa = 68.9476;
        var PSI_to_P = 6894.76;
        var PSI_to_mBar = 68.9476;
        var PSI_to_cmH2O = 70.3072190698913;
        var PSI_to_inH2O = 27.7075852285322;
        var PSI_to_mmHg = 51.7148649207728;
        var PSI_to_cmHg = 5.17148649207728;
        var PSI_to_inHg = 2.03602065760124;
        var kPaTohPa = (function () {
            function kPaTohPa() {
            }
            kPaTohPa.getFrom = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            kPaTohPa.getTo = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            kPaTohPa.convert = function (value, precision) {
                var exactVal = value * kPa_to_hPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            kPaTohPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return kPaTohPa;
        }());
        Pressure.kPaTohPa = kPaTohPa;
        var kPaToP = (function () {
            function kPaToP() {
            }
            kPaToP.getFrom = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            kPaToP.getTo = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            kPaToP.convert = function (value, precision) {
                var exactVal = value * kPa_to_P;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            kPaToP.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return kPaToP;
        }());
        Pressure.kPaToP = kPaToP;
        var kPaTomBar = (function () {
            function kPaTomBar() {
            }
            kPaTomBar.getFrom = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            kPaTomBar.getTo = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            kPaTomBar.convert = function (value, precision) {
                var exactVal = value * kPa_to_mBar;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            kPaTomBar.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return kPaTomBar;
        }());
        Pressure.kPaTomBar = kPaTomBar;
        var kPaTocmH20 = (function () {
            function kPaTocmH20() {
            }
            kPaTocmH20.getFrom = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            kPaTocmH20.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            kPaTocmH20.convert = function (value, precision) {
                var exactVal = value * kPa_to_cmH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            kPaTocmH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return kPaTocmH20;
        }());
        Pressure.kPaTocmH20 = kPaTocmH20;
        var kPaToinH20 = (function () {
            function kPaToinH20() {
            }
            kPaToinH20.getFrom = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            kPaToinH20.getTo = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            kPaToinH20.convert = function (value, precision) {
                var exactVal = value * kPa_to_inH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            kPaToinH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return kPaToinH20;
        }());
        Pressure.kPaToinH20 = kPaToinH20;
        var kPaTommHg = (function () {
            function kPaTommHg() {
            }
            kPaTommHg.getFrom = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            kPaTommHg.getTo = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            kPaTommHg.convert = function (value, precision) {
                var exactVal = value * kPa_to_mmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            kPaTommHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return kPaTommHg;
        }());
        Pressure.kPaTommHg = kPaTommHg;
        var kPaTocmHg = (function () {
            function kPaTocmHg() {
            }
            kPaTocmHg.getFrom = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            kPaTocmHg.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            kPaTocmHg.convert = function (value, precision) {
                var exactVal = value * kPa_to_cmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            kPaTocmHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return kPaTocmHg;
        }());
        Pressure.kPaTocmHg = kPaTocmHg;
        var kPaToinHg = (function () {
            function kPaToinHg() {
            }
            kPaToinHg.getFrom = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            kPaToinHg.getTo = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            kPaToinHg.convert = function (value, precision) {
                var exactVal = value * kPa_to_inHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            kPaToinHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return kPaToinHg;
        }());
        Pressure.kPaToinHg = kPaToinHg;
        var kPaToPSI = (function () {
            function kPaToPSI() {
            }
            kPaToPSI.getFrom = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            kPaToPSI.getTo = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            kPaToPSI.convert = function (value, precision) {
                var exactVal = value * kPa_to_PSI;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            kPaToPSI.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return kPaToPSI;
        }());
        Pressure.kPaToPSI = kPaToPSI;
        var hPaTokPa = (function () {
            function hPaTokPa() {
            }
            hPaTokPa.getFrom = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            hPaTokPa.getTo = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            hPaTokPa.convert = function (value, precision) {
                var exactVal = value * hPa_to_kPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            hPaTokPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return hPaTokPa;
        }());
        Pressure.hPaTokPa = hPaTokPa;
        var hPaToP = (function () {
            function hPaToP() {
            }
            hPaToP.getFrom = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            hPaToP.getTo = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            hPaToP.convert = function (value, precision) {
                var exactVal = value * hPa_to_P;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            hPaToP.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return hPaToP;
        }());
        Pressure.hPaToP = hPaToP;
        var hPaTomBar = (function () {
            function hPaTomBar() {
            }
            hPaTomBar.getFrom = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            hPaTomBar.getTo = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            hPaTomBar.convert = function (value, precision) {
                var exactVal = value * hPa_to_mBar;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            hPaTomBar.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return hPaTomBar;
        }());
        Pressure.hPaTomBar = hPaTomBar;
        var hPaTocmH20 = (function () {
            function hPaTocmH20() {
            }
            hPaTocmH20.getFrom = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            hPaTocmH20.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            hPaTocmH20.convert = function (value, precision) {
                var exactVal = value * hPa_to_cmH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            hPaTocmH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return hPaTocmH20;
        }());
        Pressure.hPaTocmH20 = hPaTocmH20;
        var hPaToinH20 = (function () {
            function hPaToinH20() {
            }
            hPaToinH20.getFrom = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            hPaToinH20.getTo = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            hPaToinH20.convert = function (value, precision) {
                var exactVal = value * hPa_to_inH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            hPaToinH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return hPaToinH20;
        }());
        Pressure.hPaToinH20 = hPaToinH20;
        var hPaTommHg = (function () {
            function hPaTommHg() {
            }
            hPaTommHg.getFrom = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            hPaTommHg.getTo = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            hPaTommHg.convert = function (value, precision) {
                var exactVal = value * hPa_to_mmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            hPaTommHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return hPaTommHg;
        }());
        Pressure.hPaTommHg = hPaTommHg;
        var hPaTocmHg = (function () {
            function hPaTocmHg() {
            }
            hPaTocmHg.getFrom = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            hPaTocmHg.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            hPaTocmHg.convert = function (value, precision) {
                var exactVal = value * hPa_to_cmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            hPaTocmHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return hPaTocmHg;
        }());
        Pressure.hPaTocmHg = hPaTocmHg;
        var hPaToinHg = (function () {
            function hPaToinHg() {
            }
            hPaToinHg.getFrom = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            hPaToinHg.getTo = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            hPaToinHg.convert = function (value, precision) {
                var exactVal = value * hPa_to_inHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            hPaToinHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return hPaToinHg;
        }());
        Pressure.hPaToinHg = hPaToinHg;
        var hPaToPSI = (function () {
            function hPaToPSI() {
            }
            hPaToPSI.getFrom = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            hPaToPSI.getTo = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            hPaToPSI.convert = function (value, precision) {
                var exactVal = value * hPa_to_PSI;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            hPaToPSI.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return hPaToPSI;
        }());
        Pressure.hPaToPSI = hPaToPSI;
        var PTokPa = (function () {
            function PTokPa() {
            }
            PTokPa.getFrom = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            PTokPa.getTo = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            PTokPa.convert = function (value, precision) {
                var exactVal = value * P_to_kPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PTokPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PTokPa;
        }());
        Pressure.PTokPa = PTokPa;
        var PTohPa = (function () {
            function PTohPa() {
            }
            PTohPa.getFrom = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            PTohPa.getTo = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            PTohPa.convert = function (value, precision) {
                var exactVal = value * P_to_hPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PTohPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PTohPa;
        }());
        Pressure.PTohPa = PTohPa;
        var PTomBar = (function () {
            function PTomBar() {
            }
            PTomBar.getFrom = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            PTomBar.getTo = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            PTomBar.convert = function (value, precision) {
                var exactVal = value * P_to_mBar;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PTomBar.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PTomBar;
        }());
        Pressure.PTomBar = PTomBar;
        var PTocmH20 = (function () {
            function PTocmH20() {
            }
            PTocmH20.getFrom = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            PTocmH20.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            PTocmH20.convert = function (value, precision) {
                var exactVal = value * P_to_cmH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PTocmH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PTocmH20;
        }());
        Pressure.PTocmH20 = PTocmH20;
        var PToinH20 = (function () {
            function PToinH20() {
            }
            PToinH20.getFrom = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            PToinH20.getTo = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            PToinH20.convert = function (value, precision) {
                var exactVal = value * P_to_inH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PToinH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PToinH20;
        }());
        Pressure.PToinH20 = PToinH20;
        var PTommHg = (function () {
            function PTommHg() {
            }
            PTommHg.getFrom = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            PTommHg.getTo = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            PTommHg.convert = function (value, precision) {
                var exactVal = value * P_to_mmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PTommHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PTommHg;
        }());
        Pressure.PTommHg = PTommHg;
        var PTocmHg = (function () {
            function PTocmHg() {
            }
            PTocmHg.getFrom = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            PTocmHg.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            PTocmHg.convert = function (value, precision) {
                var exactVal = value * P_to_cmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PTocmHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PTocmHg;
        }());
        Pressure.PTocmHg = PTocmHg;
        var PToinHg = (function () {
            function PToinHg() {
            }
            PToinHg.getFrom = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            PToinHg.getTo = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            PToinHg.convert = function (value, precision) {
                var exactVal = value * P_to_inHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PToinHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PToinHg;
        }());
        Pressure.PToinHg = PToinHg;
        var PToPSI = (function () {
            function PToPSI() {
            }
            PToPSI.getFrom = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            PToPSI.getTo = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            PToPSI.convert = function (value, precision) {
                var exactVal = value * P_to_PSI;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PToPSI.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PToPSI;
        }());
        Pressure.PToPSI = PToPSI;
        var mBarTokPa = (function () {
            function mBarTokPa() {
            }
            mBarTokPa.getFrom = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            mBarTokPa.getTo = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            mBarTokPa.convert = function (value, precision) {
                var exactVal = value * mBar_to_kPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mBarTokPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mBarTokPa;
        }());
        Pressure.mBarTokPa = mBarTokPa;
        var mBarTohPa = (function () {
            function mBarTohPa() {
            }
            mBarTohPa.getFrom = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            mBarTohPa.getTo = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            mBarTohPa.convert = function (value, precision) {
                var exactVal = value * mBar_to_hPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mBarTohPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mBarTohPa;
        }());
        Pressure.mBarTohPa = mBarTohPa;
        var mBarToP = (function () {
            function mBarToP() {
            }
            mBarToP.getFrom = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            mBarToP.getTo = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            mBarToP.convert = function (value, precision) {
                var exactVal = value * mBar_to_P;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mBarToP.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mBarToP;
        }());
        Pressure.mBarToP = mBarToP;
        var mBarTocmH20 = (function () {
            function mBarTocmH20() {
            }
            mBarTocmH20.getFrom = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            mBarTocmH20.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            mBarTocmH20.convert = function (value, precision) {
                var exactVal = value * mBar_to_cmH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mBarTocmH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mBarTocmH20;
        }());
        Pressure.mBarTocmH20 = mBarTocmH20;
        var mBarToinH20 = (function () {
            function mBarToinH20() {
            }
            mBarToinH20.getFrom = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            mBarToinH20.getTo = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            mBarToinH20.convert = function (value, precision) {
                var exactVal = value * mBar_to_inH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mBarToinH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mBarToinH20;
        }());
        Pressure.mBarToinH20 = mBarToinH20;
        var mBarTommHg = (function () {
            function mBarTommHg() {
            }
            mBarTommHg.getFrom = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            mBarTommHg.getTo = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            mBarTommHg.convert = function (value, precision) {
                var exactVal = value * mBar_to_mmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mBarTommHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mBarTommHg;
        }());
        Pressure.mBarTommHg = mBarTommHg;
        var mBarTocmHg = (function () {
            function mBarTocmHg() {
            }
            mBarTocmHg.getFrom = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            mBarTocmHg.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            mBarTocmHg.convert = function (value, precision) {
                var exactVal = value * mBar_to_cmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mBarTocmHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mBarTocmHg;
        }());
        Pressure.mBarTocmHg = mBarTocmHg;
        var mBarToinHg = (function () {
            function mBarToinHg() {
            }
            mBarToinHg.getFrom = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            mBarToinHg.getTo = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            mBarToinHg.convert = function (value, precision) {
                var exactVal = value * mBar_to_inHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mBarToinHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mBarToinHg;
        }());
        Pressure.mBarToinHg = mBarToinHg;
        var mBarToPSI = (function () {
            function mBarToPSI() {
            }
            mBarToPSI.getFrom = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            mBarToPSI.getTo = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            mBarToPSI.convert = function (value, precision) {
                var exactVal = value * mBar_to_PSI;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mBarToPSI.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mBarToPSI;
        }());
        Pressure.mBarToPSI = mBarToPSI;
        var cmH20TokPa = (function () {
            function cmH20TokPa() {
            }
            cmH20TokPa.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            cmH20TokPa.getTo = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            cmH20TokPa.convert = function (value, precision) {
                var exactVal = value * cmH2O_to_kPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmH20TokPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmH20TokPa;
        }());
        Pressure.cmH20TokPa = cmH20TokPa;
        var cmH20TohPa = (function () {
            function cmH20TohPa() {
            }
            cmH20TohPa.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            cmH20TohPa.getTo = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            cmH20TohPa.convert = function (value, precision) {
                var exactVal = value * cmH2O_to_hPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmH20TohPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmH20TohPa;
        }());
        Pressure.cmH20TohPa = cmH20TohPa;
        var cmH20ToP = (function () {
            function cmH20ToP() {
            }
            cmH20ToP.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            cmH20ToP.getTo = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            cmH20ToP.convert = function (value, precision) {
                var exactVal = value * cmH2O_to_P;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmH20ToP.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmH20ToP;
        }());
        Pressure.cmH20ToP = cmH20ToP;
        var cmH20TomBar = (function () {
            function cmH20TomBar() {
            }
            cmH20TomBar.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            cmH20TomBar.getTo = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            cmH20TomBar.convert = function (value, precision) {
                var exactVal = value * cmH2O_to_mBar;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmH20TomBar.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmH20TomBar;
        }());
        Pressure.cmH20TomBar = cmH20TomBar;
        var cmH20ToinH20 = (function () {
            function cmH20ToinH20() {
            }
            cmH20ToinH20.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            cmH20ToinH20.getTo = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            cmH20ToinH20.convert = function (value, precision) {
                var exactVal = value * cmH2O_to_inH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmH20ToinH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmH20ToinH20;
        }());
        Pressure.cmH20ToinH20 = cmH20ToinH20;
        var cmH20TommHg = (function () {
            function cmH20TommHg() {
            }
            cmH20TommHg.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            cmH20TommHg.getTo = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            cmH20TommHg.convert = function (value, precision) {
                var exactVal = value * cmH2O_to_mmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmH20TommHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmH20TommHg;
        }());
        Pressure.cmH20TommHg = cmH20TommHg;
        var cmH20TocmHg = (function () {
            function cmH20TocmHg() {
            }
            cmH20TocmHg.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            cmH20TocmHg.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            cmH20TocmHg.convert = function (value, precision) {
                var exactVal = value * cmH2O_to_cmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmH20TocmHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmH20TocmHg;
        }());
        Pressure.cmH20TocmHg = cmH20TocmHg;
        var cmH20ToinHg = (function () {
            function cmH20ToinHg() {
            }
            cmH20ToinHg.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            cmH20ToinHg.getTo = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            cmH20ToinHg.convert = function (value, precision) {
                var exactVal = value * cmH2O_to_inHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmH20ToinHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmH20ToinHg;
        }());
        Pressure.cmH20ToinHg = cmH20ToinHg;
        var cmH20ToPSI = (function () {
            function cmH20ToPSI() {
            }
            cmH20ToPSI.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            cmH20ToPSI.getTo = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            cmH20ToPSI.convert = function (value, precision) {
                var exactVal = value * cmH2O_to_PSI;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmH20ToPSI.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmH20ToPSI;
        }());
        Pressure.cmH20ToPSI = cmH20ToPSI;
        var inH20TokPa = (function () {
            function inH20TokPa() {
            }
            inH20TokPa.getFrom = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            inH20TokPa.getTo = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            inH20TokPa.convert = function (value, precision) {
                var exactVal = value * inH2O_to_kPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inH20TokPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inH20TokPa;
        }());
        Pressure.inH20TokPa = inH20TokPa;
        var inH20TohPa = (function () {
            function inH20TohPa() {
            }
            inH20TohPa.getFrom = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            inH20TohPa.getTo = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            inH20TohPa.convert = function (value, precision) {
                var exactVal = value * inH2O_to_hPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inH20TohPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inH20TohPa;
        }());
        Pressure.inH20TohPa = inH20TohPa;
        var inH20ToP = (function () {
            function inH20ToP() {
            }
            inH20ToP.getFrom = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            inH20ToP.getTo = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            inH20ToP.convert = function (value, precision) {
                var exactVal = value * inH2O_to_P;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inH20ToP.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inH20ToP;
        }());
        Pressure.inH20ToP = inH20ToP;
        var inH20TomBar = (function () {
            function inH20TomBar() {
            }
            inH20TomBar.getFrom = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            inH20TomBar.getTo = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            inH20TomBar.convert = function (value, precision) {
                var exactVal = value * inH2O_to_mBar;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inH20TomBar.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inH20TomBar;
        }());
        Pressure.inH20TomBar = inH20TomBar;
        var inH20TocmH20 = (function () {
            function inH20TocmH20() {
            }
            inH20TocmH20.getFrom = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            inH20TocmH20.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            inH20TocmH20.convert = function (value, precision) {
                var exactVal = value * inH2O_to_cmH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inH20TocmH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inH20TocmH20;
        }());
        Pressure.inH20TocmH20 = inH20TocmH20;
        var inH20TommHg = (function () {
            function inH20TommHg() {
            }
            inH20TommHg.getFrom = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            inH20TommHg.getTo = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            inH20TommHg.convert = function (value, precision) {
                var exactVal = value * inH2O_to_mmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inH20TommHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inH20TommHg;
        }());
        Pressure.inH20TommHg = inH20TommHg;
        var inH20TocmHg = (function () {
            function inH20TocmHg() {
            }
            inH20TocmHg.getFrom = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            inH20TocmHg.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            inH20TocmHg.convert = function (value, precision) {
                var exactVal = value * inH2O_to_cmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inH20TocmHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inH20TocmHg;
        }());
        Pressure.inH20TocmHg = inH20TocmHg;
        var inH20ToinHg = (function () {
            function inH20ToinHg() {
            }
            inH20ToinHg.getFrom = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            inH20ToinHg.getTo = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            inH20ToinHg.convert = function (value, precision) {
                var exactVal = value * inH2O_to_inHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inH20ToinHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inH20ToinHg;
        }());
        Pressure.inH20ToinHg = inH20ToinHg;
        var inH20ToPSI = (function () {
            function inH20ToPSI() {
            }
            inH20ToPSI.getFrom = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            inH20ToPSI.getTo = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            inH20ToPSI.convert = function (value, precision) {
                var exactVal = value * inH2O_to_PSI;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inH20ToPSI.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inH20ToPSI;
        }());
        Pressure.inH20ToPSI = inH20ToPSI;
        var mmHgTokPa = (function () {
            function mmHgTokPa() {
            }
            mmHgTokPa.getFrom = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            mmHgTokPa.getTo = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            mmHgTokPa.convert = function (value, precision) {
                var exactVal = value * mmHg_to_kPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mmHgTokPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mmHgTokPa;
        }());
        Pressure.mmHgTokPa = mmHgTokPa;
        var mmHgTohPa = (function () {
            function mmHgTohPa() {
            }
            mmHgTohPa.getFrom = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            mmHgTohPa.getTo = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            mmHgTohPa.convert = function (value, precision) {
                var exactVal = value * mmHg_to_hPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mmHgTohPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mmHgTohPa;
        }());
        Pressure.mmHgTohPa = mmHgTohPa;
        var mmHgToP = (function () {
            function mmHgToP() {
            }
            mmHgToP.getFrom = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            mmHgToP.getTo = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            mmHgToP.convert = function (value, precision) {
                var exactVal = value * mmHg_to_P;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mmHgToP.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mmHgToP;
        }());
        Pressure.mmHgToP = mmHgToP;
        var mmHgTomBar = (function () {
            function mmHgTomBar() {
            }
            mmHgTomBar.getFrom = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            mmHgTomBar.getTo = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            mmHgTomBar.convert = function (value, precision) {
                var exactVal = value * mmHg_to_mBar;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mmHgTomBar.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mmHgTomBar;
        }());
        Pressure.mmHgTomBar = mmHgTomBar;
        var mmHgTocmH20 = (function () {
            function mmHgTocmH20() {
            }
            mmHgTocmH20.getFrom = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            mmHgTocmH20.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            mmHgTocmH20.convert = function (value, precision) {
                var exactVal = value * mmHg_to_cmH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mmHgTocmH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mmHgTocmH20;
        }());
        Pressure.mmHgTocmH20 = mmHgTocmH20;
        var mmHgToinH20 = (function () {
            function mmHgToinH20() {
            }
            mmHgToinH20.getFrom = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            mmHgToinH20.getTo = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            mmHgToinH20.convert = function (value, precision) {
                var exactVal = value * mmHg_to_inH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mmHgToinH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mmHgToinH20;
        }());
        Pressure.mmHgToinH20 = mmHgToinH20;
        var mmHgTocmHg = (function () {
            function mmHgTocmHg() {
            }
            mmHgTocmHg.getFrom = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            mmHgTocmHg.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            mmHgTocmHg.convert = function (value, precision) {
                var exactVal = value * mmHg_to_cmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mmHgTocmHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mmHgTocmHg;
        }());
        Pressure.mmHgTocmHg = mmHgTocmHg;
        var mmHgToinHg = (function () {
            function mmHgToinHg() {
            }
            mmHgToinHg.getFrom = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            mmHgToinHg.getTo = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            mmHgToinHg.convert = function (value, precision) {
                var exactVal = value * mmHg_to_inHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mmHgToinHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mmHgToinHg;
        }());
        Pressure.mmHgToinHg = mmHgToinHg;
        var mmHgToPSI = (function () {
            function mmHgToPSI() {
            }
            mmHgToPSI.getFrom = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            mmHgToPSI.getTo = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            mmHgToPSI.convert = function (value, precision) {
                var exactVal = value * mmHg_to_PSI;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mmHgToPSI.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mmHgToPSI;
        }());
        Pressure.mmHgToPSI = mmHgToPSI;
        var cmHgTokPa = (function () {
            function cmHgTokPa() {
            }
            cmHgTokPa.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            cmHgTokPa.getTo = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            cmHgTokPa.convert = function (value, precision) {
                var exactVal = value * cmHg_to_kPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmHgTokPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmHgTokPa;
        }());
        Pressure.cmHgTokPa = cmHgTokPa;
        var cmHgTohPa = (function () {
            function cmHgTohPa() {
            }
            cmHgTohPa.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            cmHgTohPa.getTo = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            cmHgTohPa.convert = function (value, precision) {
                var exactVal = value * cmHg_to_hPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmHgTohPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmHgTohPa;
        }());
        Pressure.cmHgTohPa = cmHgTohPa;
        var cmHgToP = (function () {
            function cmHgToP() {
            }
            cmHgToP.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            cmHgToP.getTo = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            cmHgToP.convert = function (value, precision) {
                var exactVal = value * cmHg_to_P;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmHgToP.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmHgToP;
        }());
        Pressure.cmHgToP = cmHgToP;
        var cmHgTomBar = (function () {
            function cmHgTomBar() {
            }
            cmHgTomBar.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            cmHgTomBar.getTo = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            cmHgTomBar.convert = function (value, precision) {
                var exactVal = value * cmHg_to_mBar;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmHgTomBar.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmHgTomBar;
        }());
        Pressure.cmHgTomBar = cmHgTomBar;
        var cmHgTocmH20 = (function () {
            function cmHgTocmH20() {
            }
            cmHgTocmH20.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            cmHgTocmH20.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            cmHgTocmH20.convert = function (value, precision) {
                var exactVal = value * cmHg_to_cmH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmHgTocmH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmHgTocmH20;
        }());
        Pressure.cmHgTocmH20 = cmHgTocmH20;
        var cmHgToinH20 = (function () {
            function cmHgToinH20() {
            }
            cmHgToinH20.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            cmHgToinH20.getTo = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            cmHgToinH20.convert = function (value, precision) {
                var exactVal = value * cmHg_to_inH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmHgToinH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmHgToinH20;
        }());
        Pressure.cmHgToinH20 = cmHgToinH20;
        var cmHgTommHg = (function () {
            function cmHgTommHg() {
            }
            cmHgTommHg.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            cmHgTommHg.getTo = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            cmHgTommHg.convert = function (value, precision) {
                var exactVal = value * cmHg_to_mmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmHgTommHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmHgTommHg;
        }());
        Pressure.cmHgTommHg = cmHgTommHg;
        var cmHgToinHg = (function () {
            function cmHgToinHg() {
            }
            cmHgToinHg.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            cmHgToinHg.getTo = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            cmHgToinHg.convert = function (value, precision) {
                var exactVal = value * cmHg_to_inHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmHgToinHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmHgToinHg;
        }());
        Pressure.cmHgToinHg = cmHgToinHg;
        var cmHgToPSI = (function () {
            function cmHgToPSI() {
            }
            cmHgToPSI.getFrom = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            cmHgToPSI.getTo = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            cmHgToPSI.convert = function (value, precision) {
                var exactVal = value * cmHg_to_PSI;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            cmHgToPSI.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return cmHgToPSI;
        }());
        Pressure.cmHgToPSI = cmHgToPSI;
        var inHgTokPa = (function () {
            function inHgTokPa() {
            }
            inHgTokPa.getFrom = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            inHgTokPa.getTo = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            inHgTokPa.convert = function (value, precision) {
                var exactVal = value * inHg_to_kPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inHgTokPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inHgTokPa;
        }());
        Pressure.inHgTokPa = inHgTokPa;
        var inHgTohPa = (function () {
            function inHgTohPa() {
            }
            inHgTohPa.getFrom = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            inHgTohPa.getTo = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            inHgTohPa.convert = function (value, precision) {
                var exactVal = value * inHg_to_hPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inHgTohPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inHgTohPa;
        }());
        Pressure.inHgTohPa = inHgTohPa;
        var inHgToP = (function () {
            function inHgToP() {
            }
            inHgToP.getFrom = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            inHgToP.getTo = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            inHgToP.convert = function (value, precision) {
                var exactVal = value * inHg_to_P;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inHgToP.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inHgToP;
        }());
        Pressure.inHgToP = inHgToP;
        var inHgTomBar = (function () {
            function inHgTomBar() {
            }
            inHgTomBar.getFrom = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            inHgTomBar.getTo = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            inHgTomBar.convert = function (value, precision) {
                var exactVal = value * inHg_to_mBar;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inHgTomBar.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inHgTomBar;
        }());
        Pressure.inHgTomBar = inHgTomBar;
        var inHgTocmH20 = (function () {
            function inHgTocmH20() {
            }
            inHgTocmH20.getFrom = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            inHgTocmH20.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            inHgTocmH20.convert = function (value, precision) {
                var exactVal = value * inHg_to_cmH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inHgTocmH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inHgTocmH20;
        }());
        Pressure.inHgTocmH20 = inHgTocmH20;
        var inHgToinH20 = (function () {
            function inHgToinH20() {
            }
            inHgToinH20.getFrom = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            inHgToinH20.getTo = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            inHgToinH20.convert = function (value, precision) {
                var exactVal = value * inHg_to_inH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inHgToinH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inHgToinH20;
        }());
        Pressure.inHgToinH20 = inHgToinH20;
        var inHgTommHg = (function () {
            function inHgTommHg() {
            }
            inHgTommHg.getFrom = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            inHgTommHg.getTo = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            inHgTommHg.convert = function (value, precision) {
                var exactVal = value * inHg_to_mmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inHgTommHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inHgTommHg;
        }());
        Pressure.inHgTommHg = inHgTommHg;
        var inHgTocmHg = (function () {
            function inHgTocmHg() {
            }
            inHgTocmHg.getFrom = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            inHgTocmHg.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            inHgTocmHg.convert = function (value, precision) {
                var exactVal = value * inHg_to_cmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inHgTocmHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inHgTocmHg;
        }());
        Pressure.inHgTocmHg = inHgTocmHg;
        var inHgToPSI = (function () {
            function inHgToPSI() {
            }
            inHgToPSI.getFrom = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            inHgToPSI.getTo = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            inHgToPSI.convert = function (value, precision) {
                var exactVal = value * inHg_to_PSI;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            inHgToPSI.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return inHgToPSI;
        }());
        Pressure.inHgToPSI = inHgToPSI;
        var PSITokPa = (function () {
            function PSITokPa() {
            }
            PSITokPa.getFrom = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            PSITokPa.getTo = function () {
                return UnitOfMeasure$1.KILOPASCAL;
            };
            PSITokPa.convert = function (value, precision) {
                var exactVal = value * PSI_to_kPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PSITokPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PSITokPa;
        }());
        Pressure.PSITokPa = PSITokPa;
        var PSITohPa = (function () {
            function PSITohPa() {
            }
            PSITohPa.getFrom = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            PSITohPa.getTo = function () {
                return UnitOfMeasure$1.HECTOPASCAL;
            };
            PSITohPa.convert = function (value, precision) {
                var exactVal = value * PSI_to_hPa;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PSITohPa.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PSITohPa;
        }());
        Pressure.PSITohPa = PSITohPa;
        var PSIToP = (function () {
            function PSIToP() {
            }
            PSIToP.getFrom = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            PSIToP.getTo = function () {
                return UnitOfMeasure$1.PASCAL;
            };
            PSIToP.convert = function (value, precision) {
                var exactVal = value * PSI_to_P;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PSIToP.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PSIToP;
        }());
        Pressure.PSIToP = PSIToP;
        var PSITomBar = (function () {
            function PSITomBar() {
            }
            PSITomBar.getFrom = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            PSITomBar.getTo = function () {
                return UnitOfMeasure$1.MILLIBAR;
            };
            PSITomBar.convert = function (value, precision) {
                var exactVal = value * PSI_to_mBar;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PSITomBar.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PSITomBar;
        }());
        Pressure.PSITomBar = PSITomBar;
        var PSITocmH20 = (function () {
            function PSITocmH20() {
            }
            PSITocmH20.getFrom = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            PSITocmH20.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_WATER;
            };
            PSITocmH20.convert = function (value, precision) {
                var exactVal = value * PSI_to_cmH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PSITocmH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PSITocmH20;
        }());
        Pressure.PSITocmH20 = PSITocmH20;
        var PSIToinH20 = (function () {
            function PSIToinH20() {
            }
            PSIToinH20.getFrom = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            PSIToinH20.getTo = function () {
                return UnitOfMeasure$1.INCH_WATER;
            };
            PSIToinH20.convert = function (value, precision) {
                var exactVal = value * PSI_to_inH2O;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PSIToinH20.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PSIToinH20;
        }());
        Pressure.PSIToinH20 = PSIToinH20;
        var PSITommHg = (function () {
            function PSITommHg() {
            }
            PSITommHg.getFrom = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            PSITommHg.getTo = function () {
                return UnitOfMeasure$1.MILLIMETER_MERCURY;
            };
            PSITommHg.convert = function (value, precision) {
                var exactVal = value * PSI_to_mmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PSITommHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PSITommHg;
        }());
        Pressure.PSITommHg = PSITommHg;
        var PSITocmHg = (function () {
            function PSITocmHg() {
            }
            PSITocmHg.getFrom = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            PSITocmHg.getTo = function () {
                return UnitOfMeasure$1.CENTIMETER_MERCURY;
            };
            PSITocmHg.convert = function (value, precision) {
                var exactVal = value * PSI_to_cmHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PSITocmHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PSITocmHg;
        }());
        Pressure.PSITocmHg = PSITocmHg;
        var PSIToinHg = (function () {
            function PSIToinHg() {
            }
            PSIToinHg.getFrom = function () {
                return UnitOfMeasure$1.POUND_SQUARE_INCH;
            };
            PSIToinHg.getTo = function () {
                return UnitOfMeasure$1.INCH_MERCURY;
            };
            PSIToinHg.convert = function (value, precision) {
                var exactVal = value * PSI_to_inHg;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PSIToinHg.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PSIToinHg;
        }());
        Pressure.PSIToinHg = PSIToinHg;
    })(Pressure || (Pressure = {}));

    var ParticleConcentration;
    (function (ParticleConcentration) {
        var L_MOD = 1000;
        var DECIL_MOD = 100;
        var M3_MOD = 1000000;
        var FT3_MOD = 28316.8465919997;
        var Cm3ToL = (function () {
            function Cm3ToL() {
            }
            Cm3ToL.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_CENTIMETER;
            };
            Cm3ToL.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_LITER;
            };
            Cm3ToL.convert = function (value, precision) {
                var exactVal = value * L_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            Cm3ToL.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return Cm3ToL;
        }());
        ParticleConcentration.Cm3ToL = Cm3ToL;
        var Cm3ToDeciL = (function () {
            function Cm3ToDeciL() {
            }
            Cm3ToDeciL.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_CENTIMETER;
            };
            Cm3ToDeciL.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_DECILITER;
            };
            Cm3ToDeciL.convert = function (value, precision) {
                var exactVal = value * DECIL_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            Cm3ToDeciL.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return Cm3ToDeciL;
        }());
        ParticleConcentration.Cm3ToDeciL = Cm3ToDeciL;
        var Cm3ToM3 = (function () {
            function Cm3ToM3() {
            }
            Cm3ToM3.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_CENTIMETER;
            };
            Cm3ToM3.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_METER;
            };
            Cm3ToM3.convert = function (value, precision) {
                var exactVal = value * M3_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            Cm3ToM3.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return Cm3ToM3;
        }());
        ParticleConcentration.Cm3ToM3 = Cm3ToM3;
        var Cm3ToFt3 = (function () {
            function Cm3ToFt3() {
            }
            Cm3ToFt3.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_CENTIMETER;
            };
            Cm3ToFt3.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_FOOT;
            };
            Cm3ToFt3.convert = function (value, precision) {
                var exactVal = value * FT3_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            Cm3ToFt3.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return Cm3ToFt3;
        }());
        ParticleConcentration.Cm3ToFt3 = Cm3ToFt3;
        var LToCm3 = (function () {
            function LToCm3() {
            }
            LToCm3.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_LITER;
            };
            LToCm3.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_CENTIMETER;
            };
            LToCm3.convert = function (value, precision) {
                var exactVal = value / L_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            LToCm3.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return LToCm3;
        }());
        ParticleConcentration.LToCm3 = LToCm3;
        var LToDeciL = (function () {
            function LToDeciL() {
            }
            LToDeciL.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_LITER;
            };
            LToDeciL.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_DECILITER;
            };
            LToDeciL.convert = function (value, precision) {
                var exactVal = (value * DECIL_MOD) / L_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            LToDeciL.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return LToDeciL;
        }());
        ParticleConcentration.LToDeciL = LToDeciL;
        var LToM3 = (function () {
            function LToM3() {
            }
            LToM3.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_LITER;
            };
            LToM3.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_METER;
            };
            LToM3.convert = function (value, precision) {
                var exactVal = (value * M3_MOD) / L_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            LToM3.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return LToM3;
        }());
        ParticleConcentration.LToM3 = LToM3;
        var LToFt3 = (function () {
            function LToFt3() {
            }
            LToFt3.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_LITER;
            };
            LToFt3.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_FOOT;
            };
            LToFt3.convert = function (value, precision) {
                var exactVal = (value * FT3_MOD) / L_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            LToFt3.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return LToFt3;
        }());
        ParticleConcentration.LToFt3 = LToFt3;
        var DeciLToCm3 = (function () {
            function DeciLToCm3() {
            }
            DeciLToCm3.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_DECILITER;
            };
            DeciLToCm3.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_CENTIMETER;
            };
            DeciLToCm3.convert = function (value, precision) {
                var exactVal = value / DECIL_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            DeciLToCm3.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return DeciLToCm3;
        }());
        ParticleConcentration.DeciLToCm3 = DeciLToCm3;
        var DeciLToL = (function () {
            function DeciLToL() {
            }
            DeciLToL.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_DECILITER;
            };
            DeciLToL.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_LITER;
            };
            DeciLToL.convert = function (value, precision) {
                var exactVal = (value * L_MOD) / DECIL_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            DeciLToL.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return DeciLToL;
        }());
        ParticleConcentration.DeciLToL = DeciLToL;
        var DeciLToM3 = (function () {
            function DeciLToM3() {
            }
            DeciLToM3.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_DECILITER;
            };
            DeciLToM3.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_METER;
            };
            DeciLToM3.convert = function (value, precision) {
                var exactVal = (value * M3_MOD) / DECIL_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            DeciLToM3.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return DeciLToM3;
        }());
        ParticleConcentration.DeciLToM3 = DeciLToM3;
        var DeciLToFt3 = (function () {
            function DeciLToFt3() {
            }
            DeciLToFt3.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_DECILITER;
            };
            DeciLToFt3.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_FOOT;
            };
            DeciLToFt3.convert = function (value, precision) {
                var exactVal = (value * FT3_MOD) / DECIL_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            DeciLToFt3.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return DeciLToFt3;
        }());
        ParticleConcentration.DeciLToFt3 = DeciLToFt3;
        var M3ToCm3 = (function () {
            function M3ToCm3() {
            }
            M3ToCm3.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_METER;
            };
            M3ToCm3.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_CENTIMETER;
            };
            M3ToCm3.convert = function (value, precision) {
                var exactVal = value / M3_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            M3ToCm3.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return M3ToCm3;
        }());
        ParticleConcentration.M3ToCm3 = M3ToCm3;
        var M3ToL = (function () {
            function M3ToL() {
            }
            M3ToL.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_METER;
            };
            M3ToL.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_LITER;
            };
            M3ToL.convert = function (value, precision) {
                var exactVal = (value * L_MOD) / M3_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            M3ToL.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return M3ToL;
        }());
        ParticleConcentration.M3ToL = M3ToL;
        var M3ToDeciL = (function () {
            function M3ToDeciL() {
            }
            M3ToDeciL.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_METER;
            };
            M3ToDeciL.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_DECILITER;
            };
            M3ToDeciL.convert = function (value, precision) {
                var exactVal = (value * DECIL_MOD) / M3_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            M3ToDeciL.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return M3ToDeciL;
        }());
        ParticleConcentration.M3ToDeciL = M3ToDeciL;
        var M3ToFt3 = (function () {
            function M3ToFt3() {
            }
            M3ToFt3.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_METER;
            };
            M3ToFt3.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_FOOT;
            };
            M3ToFt3.convert = function (value, precision) {
                var exactVal = (value * FT3_MOD) / M3_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            M3ToFt3.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return M3ToFt3;
        }());
        ParticleConcentration.M3ToFt3 = M3ToFt3;
        var Ft3ToCm3 = (function () {
            function Ft3ToCm3() {
            }
            Ft3ToCm3.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_FOOT;
            };
            Ft3ToCm3.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_CENTIMETER;
            };
            Ft3ToCm3.convert = function (value, precision) {
                var exactVal = value / FT3_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            Ft3ToCm3.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return Ft3ToCm3;
        }());
        ParticleConcentration.Ft3ToCm3 = Ft3ToCm3;
        var Ft3ToL = (function () {
            function Ft3ToL() {
            }
            Ft3ToL.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_FOOT;
            };
            Ft3ToL.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_LITER;
            };
            Ft3ToL.convert = function (value, precision) {
                var exactVal = (value * L_MOD) / FT3_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            Ft3ToL.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return Ft3ToL;
        }());
        ParticleConcentration.Ft3ToL = Ft3ToL;
        var Ft3ToDeciL = (function () {
            function Ft3ToDeciL() {
            }
            Ft3ToDeciL.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_FOOT;
            };
            Ft3ToDeciL.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_DECILITER;
            };
            Ft3ToDeciL.convert = function (value, precision) {
                var exactVal = (value * DECIL_MOD) / FT3_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            Ft3ToDeciL.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return Ft3ToDeciL;
        }());
        ParticleConcentration.Ft3ToDeciL = Ft3ToDeciL;
        var Ft3ToM3 = (function () {
            function Ft3ToM3() {
            }
            Ft3ToM3.getFrom = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_FOOT;
            };
            Ft3ToM3.getTo = function () {
                return UnitOfMeasure$1.COUNT_PER_CUBIC_METER;
            };
            Ft3ToM3.convert = function (value, precision) {
                var exactVal = (value * M3_MOD) / FT3_MOD;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            Ft3ToM3.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return Ft3ToM3;
        }());
        ParticleConcentration.Ft3ToM3 = Ft3ToM3;
    })(ParticleConcentration || (ParticleConcentration = {}));

    var ParticleMass;
    (function (ParticleMass) {
        var mG_to_uG = 1000;
        var kG_to_mG = 1000000;
        var kG_to_uG = 1000000000;
        var mGtouG = (function () {
            function mGtouG() {
            }
            mGtouG.getFrom = function () {
                return UnitOfMeasure$1.MILLIGRAMS_PER_CUBIC_METER;
            };
            mGtouG.getTo = function () {
                return UnitOfMeasure$1.MICROGRAMS_PER_CUBIC_METER;
            };
            mGtouG.convert = function (value, precision) {
                var exactVal = value * mG_to_uG;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mGtouG.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mGtouG;
        }());
        ParticleMass.mGtouG = mGtouG;
        var uGtomG = (function () {
            function uGtomG() {
            }
            uGtomG.getFrom = function () {
                return UnitOfMeasure$1.MICROGRAMS_PER_CUBIC_METER;
            };
            uGtomG.getTo = function () {
                return UnitOfMeasure$1.MILLIGRAMS_PER_CUBIC_METER;
            };
            uGtomG.convert = function (value, precision) {
                var exactVal = value / mG_to_uG;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            uGtomG.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return uGtomG;
        }());
        ParticleMass.uGtomG = uGtomG;
        var kGtomG = (function () {
            function kGtomG() {
            }
            kGtomG.getFrom = function () {
                return UnitOfMeasure$1.KILOGRAMS_PER_CUBIC_METER;
            };
            kGtomG.getTo = function () {
                return UnitOfMeasure$1.MILLIGRAMS_PER_CUBIC_METER;
            };
            kGtomG.convert = function (value, precision) {
                var exactVal = value * kG_to_mG;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            kGtomG.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return kGtomG;
        }());
        ParticleMass.kGtomG = kGtomG;
        var mGtokG = (function () {
            function mGtokG() {
            }
            mGtokG.getFrom = function () {
                return UnitOfMeasure$1.MILLIGRAMS_PER_CUBIC_METER;
            };
            mGtokG.getTo = function () {
                return UnitOfMeasure$1.KILOGRAMS_PER_CUBIC_METER;
            };
            mGtokG.convert = function (value, precision) {
                var exactVal = value / kG_to_mG;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mGtokG.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mGtokG;
        }());
        ParticleMass.mGtokG = mGtokG;
        var kGtouG = (function () {
            function kGtouG() {
            }
            kGtouG.getFrom = function () {
                return UnitOfMeasure$1.KILOGRAMS_PER_CUBIC_METER;
            };
            kGtouG.getTo = function () {
                return UnitOfMeasure$1.MICROGRAMS_PER_CUBIC_METER;
            };
            kGtouG.convert = function (value, precision) {
                var exactVal = value * kG_to_uG;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            kGtouG.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return kGtouG;
        }());
        ParticleMass.kGtouG = kGtouG;
        var uGtokG = (function () {
            function uGtokG() {
            }
            uGtokG.getFrom = function () {
                return UnitOfMeasure$1.MICROGRAMS_PER_CUBIC_METER;
            };
            uGtokG.getTo = function () {
                return UnitOfMeasure$1.KILOGRAMS_PER_CUBIC_METER;
            };
            uGtokG.convert = function (value, precision) {
                var exactVal = value / kG_to_uG;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            uGtokG.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return uGtokG;
        }());
        ParticleMass.uGtokG = uGtokG;
    })(ParticleMass || (ParticleMass = {}));

    var Gas;
    (function (Gas) {
        var MG_TO_UG = 1000;
        var PPM_TO_PPB = 1000;
        var PPM_TO_PPT = 1000000;
        var PPM_TO_PPQ = 1000000000;
        var PPB_TO_PPT = 1000;
        var PPB_TO_PPQ = 1000000;
        var PPT_TO_PPQ = 1000;
        var PpmToPpb = (function () {
            function PpmToPpb() {
            }
            PpmToPpb.getFrom = function () {
                return UnitOfMeasure$1.PARTS_PER_MILLION;
            };
            PpmToPpb.getTo = function () {
                return UnitOfMeasure$1.PARTS_PER_BILLION;
            };
            PpmToPpb.convert = function (value, precision) {
                var exactVal = value * PPM_TO_PPB;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PpmToPpb.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PpmToPpb;
        }());
        Gas.PpmToPpb = PpmToPpb;
        var PpmToPpt = (function () {
            function PpmToPpt() {
            }
            PpmToPpt.getFrom = function () {
                return UnitOfMeasure$1.PARTS_PER_MILLION;
            };
            PpmToPpt.getTo = function () {
                return UnitOfMeasure$1.PARTS_PER_TRILLION;
            };
            PpmToPpt.convert = function (value, precision) {
                var exactVal = value * PPM_TO_PPT;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PpmToPpt.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PpmToPpt;
        }());
        Gas.PpmToPpt = PpmToPpt;
        var PpmToPpq = (function () {
            function PpmToPpq() {
            }
            PpmToPpq.getFrom = function () {
                return UnitOfMeasure$1.PARTS_PER_MILLION;
            };
            PpmToPpq.getTo = function () {
                return UnitOfMeasure$1.PARTS_PER_QUADRILLION;
            };
            PpmToPpq.convert = function (value, precision) {
                var exactVal = value * PPM_TO_PPQ;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PpmToPpq.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PpmToPpq;
        }());
        Gas.PpmToPpq = PpmToPpq;
        var PpbToPpm = (function () {
            function PpbToPpm() {
            }
            PpbToPpm.getFrom = function () {
                return UnitOfMeasure$1.PARTS_PER_BILLION;
            };
            PpbToPpm.getTo = function () {
                return UnitOfMeasure$1.PARTS_PER_MILLION;
            };
            PpbToPpm.convert = function (value, precision) {
                var exactVal = value / PPM_TO_PPB;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PpbToPpm.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PpbToPpm;
        }());
        Gas.PpbToPpm = PpbToPpm;
        var PpbToPpt = (function () {
            function PpbToPpt() {
            }
            PpbToPpt.getFrom = function () {
                return UnitOfMeasure$1.PARTS_PER_BILLION;
            };
            PpbToPpt.getTo = function () {
                return UnitOfMeasure$1.PARTS_PER_TRILLION;
            };
            PpbToPpt.convert = function (value, precision) {
                var exactVal = value * PPB_TO_PPT;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PpbToPpt.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PpbToPpt;
        }());
        Gas.PpbToPpt = PpbToPpt;
        var PpbToPpq = (function () {
            function PpbToPpq() {
            }
            PpbToPpq.getFrom = function () {
                return UnitOfMeasure$1.PARTS_PER_BILLION;
            };
            PpbToPpq.getTo = function () {
                return UnitOfMeasure$1.PARTS_PER_QUADRILLION;
            };
            PpbToPpq.convert = function (value, precision) {
                var exactVal = value * PPB_TO_PPQ;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PpbToPpq.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PpbToPpq;
        }());
        Gas.PpbToPpq = PpbToPpq;
        var PptToPpm = (function () {
            function PptToPpm() {
            }
            PptToPpm.getFrom = function () {
                return UnitOfMeasure$1.PARTS_PER_TRILLION;
            };
            PptToPpm.getTo = function () {
                return UnitOfMeasure$1.PARTS_PER_MILLION;
            };
            PptToPpm.convert = function (value, precision) {
                var exactVal = value / PPM_TO_PPT;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PptToPpm.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PptToPpm;
        }());
        Gas.PptToPpm = PptToPpm;
        var PptToPpb = (function () {
            function PptToPpb() {
            }
            PptToPpb.getFrom = function () {
                return UnitOfMeasure$1.PARTS_PER_TRILLION;
            };
            PptToPpb.getTo = function () {
                return UnitOfMeasure$1.PARTS_PER_BILLION;
            };
            PptToPpb.convert = function (value, precision) {
                var exactVal = value / PPB_TO_PPT;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PptToPpb.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PptToPpb;
        }());
        Gas.PptToPpb = PptToPpb;
        var PptToPpq = (function () {
            function PptToPpq() {
            }
            PptToPpq.getFrom = function () {
                return UnitOfMeasure$1.PARTS_PER_TRILLION;
            };
            PptToPpq.getTo = function () {
                return UnitOfMeasure$1.PARTS_PER_QUADRILLION;
            };
            PptToPpq.convert = function (value, precision) {
                var exactVal = value * PPT_TO_PPQ;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PptToPpq.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PptToPpq;
        }());
        Gas.PptToPpq = PptToPpq;
        var PpqToPpm = (function () {
            function PpqToPpm() {
            }
            PpqToPpm.getFrom = function () {
                return UnitOfMeasure$1.PARTS_PER_QUADRILLION;
            };
            PpqToPpm.getTo = function () {
                return UnitOfMeasure$1.PARTS_PER_MILLION;
            };
            PpqToPpm.convert = function (value, precision) {
                var exactVal = value / PPM_TO_PPQ;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PpqToPpm.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PpqToPpm;
        }());
        Gas.PpqToPpm = PpqToPpm;
        var PpqToPpb = (function () {
            function PpqToPpb() {
            }
            PpqToPpb.getFrom = function () {
                return UnitOfMeasure$1.PARTS_PER_QUADRILLION;
            };
            PpqToPpb.getTo = function () {
                return UnitOfMeasure$1.PARTS_PER_BILLION;
            };
            PpqToPpb.convert = function (value, precision) {
                var exactVal = value / PPB_TO_PPQ;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PpqToPpb.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PpqToPpb;
        }());
        Gas.PpqToPpb = PpqToPpb;
        var PpqToPpt = (function () {
            function PpqToPpt() {
            }
            PpqToPpt.getFrom = function () {
                return UnitOfMeasure$1.PARTS_PER_QUADRILLION;
            };
            PpqToPpt.getTo = function () {
                return UnitOfMeasure$1.PARTS_PER_TRILLION;
            };
            PpqToPpt.convert = function (value, precision) {
                var exactVal = value / PPT_TO_PPQ;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            PpqToPpt.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return PpqToPpt;
        }());
        Gas.PpqToPpt = PpqToPpt;
        var MgM3ToUgM3 = (function () {
            function MgM3ToUgM3() {
            }
            MgM3ToUgM3.getFrom = function () {
                return UnitOfMeasure$1.MILLIGRAMS_PER_CUBIC_METER;
            };
            MgM3ToUgM3.getTo = function () {
                return UnitOfMeasure$1.MICROGRAMS_PER_CUBIC_METER;
            };
            MgM3ToUgM3.convert = function (value, precision) {
                var exactVal = value * MG_TO_UG;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            MgM3ToUgM3.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return MgM3ToUgM3;
        }());
        Gas.MgM3ToUgM3 = MgM3ToUgM3;
        var UgM3ToMgM3 = (function () {
            function UgM3ToMgM3() {
            }
            UgM3ToMgM3.getFrom = function () {
                return UnitOfMeasure$1.MICROGRAMS_PER_CUBIC_METER;
            };
            UgM3ToMgM3.getTo = function () {
                return UnitOfMeasure$1.MILLIGRAMS_PER_CUBIC_METER;
            };
            UgM3ToMgM3.convert = function (value, precision) {
                var exactVal = value / MG_TO_UG;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            UgM3ToMgM3.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return UgM3ToMgM3;
        }());
        Gas.UgM3ToMgM3 = UgM3ToMgM3;
    })(Gas || (Gas = {}));

    var Volume;
    (function (Volume) {
        var L_to_mL = 1000;
        var L_to_ft3 = 0.035314666721489;
        var mL_to_L = 0.001;
        var mL_to_ft3 = 0.000035314666721489;
        var ft3_to_L = 28.3168465919997;
        var ft3_to_mL = 28316.8465919997;
        var LTomL = (function () {
            function LTomL() {
            }
            LTomL.getFrom = function () {
                return UnitOfMeasure$1.LITER;
            };
            LTomL.getTo = function () {
                return UnitOfMeasure$1.MILLILITER;
            };
            LTomL.convert = function (value, precision) {
                var exactVal = value * L_to_mL;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            LTomL.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return LTomL;
        }());
        Volume.LTomL = LTomL;
        var LToft3 = (function () {
            function LToft3() {
            }
            LToft3.getFrom = function () {
                return UnitOfMeasure$1.LITER;
            };
            LToft3.getTo = function () {
                return UnitOfMeasure$1.CUBIC_FEET;
            };
            LToft3.convert = function (value, precision) {
                var exactVal = value * L_to_ft3;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            LToft3.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return LToft3;
        }());
        Volume.LToft3 = LToft3;
        var mLToL = (function () {
            function mLToL() {
            }
            mLToL.getFrom = function () {
                return UnitOfMeasure$1.MILLILITER;
            };
            mLToL.getTo = function () {
                return UnitOfMeasure$1.LITER;
            };
            mLToL.convert = function (value, precision) {
                var exactVal = value * mL_to_L;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mLToL.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mLToL;
        }());
        Volume.mLToL = mLToL;
        var mLToft3 = (function () {
            function mLToft3() {
            }
            mLToft3.getFrom = function () {
                return UnitOfMeasure$1.MILLILITER;
            };
            mLToft3.getTo = function () {
                return UnitOfMeasure$1.CUBIC_FEET;
            };
            mLToft3.convert = function (value, precision) {
                var exactVal = value * mL_to_ft3;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            mLToft3.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return mLToft3;
        }());
        Volume.mLToft3 = mLToft3;
        var ft3ToL = (function () {
            function ft3ToL() {
            }
            ft3ToL.getFrom = function () {
                return UnitOfMeasure$1.CUBIC_FEET;
            };
            ft3ToL.getTo = function () {
                return UnitOfMeasure$1.LITER;
            };
            ft3ToL.convert = function (value, precision) {
                var exactVal = value * ft3_to_L;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            ft3ToL.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return ft3ToL;
        }());
        Volume.ft3ToL = ft3ToL;
        var ft3TomL = (function () {
            function ft3TomL() {
            }
            ft3TomL.getFrom = function () {
                return UnitOfMeasure$1.CUBIC_FEET;
            };
            ft3TomL.getTo = function () {
                return UnitOfMeasure$1.MILLILITER;
            };
            ft3TomL.convert = function (value, precision) {
                var exactVal = value * ft3_to_mL;
                if (precision === null) {
                    return exactVal;
                }
                else {
                    return setPrecision(exactVal, precision);
                }
            };
            ft3TomL.convertBatch = function (values, precision) {
                for (var i = 0; i < values.length; i++) {
                    values[i] = this.convert(values[i], precision);
                }
            };
            return ft3TomL;
        }());
        Volume.ft3TomL = ft3TomL;
    })(Volume || (Volume = {}));

    var hash = [
        {
            models: ['7565'],
            data: {
                co2_ppm: {
                    resolution: 1,
                    unit: 500,
                    llod: 0,
                    ulod: 5000
                },
                temp_c: {
                    resolution: 0.1,
                    unit: 101,
                    llod: 0,
                    ulod: 60
                },
                rh_percent: {
                    resolution: 0.1,
                    unit: 1301,
                    llod: 0,
                    ulod: 95
                },
                baro_inhg: {
                    resolution: 0.01,
                    unit: 240,
                    llod: 20.36,
                    ulod: 36.648
                },
                voc_ppb: {
                    resolution: 0.01,
                    unit: 501,
                    llod: 0,
                    ulod: 20000
                },
                cl2_ppm: {
                    resolution: 0.01,
                    unit: 500,
                    llod: 0,
                    ulod: 20
                },
                co_ppm: {
                    resolution: 0.1,
                    unit: 500,
                    llod: 0,
                    ulod: 500
                }
            }
        },
        {
            models: ['7580', '7585'],
            data: {
                nh3_ppm: {
                    resolution: 0.1,
                    unit: 500,
                    llod: 0,
                    ulod: 100
                },
                nh3_mgm3: {
                    resolution: 0.1,
                    unit: 600,
                    llod: undefined,
                    ulod: undefined
                },
                baro_inhg: {
                    resolution: 0.01,
                    unit: 240,
                    llod: 7.7,
                    ulod: 37.2
                },
                ch2o_ppm: {
                    resolution: 0.01,
                    unit: 500,
                    llod: 0,
                    ulod: 10
                },
                ch2o_mgm3: {
                    resolution: 0.01,
                    unit: 600,
                    llod: undefined,
                    ulod: undefined
                },
                cl_ppm: {
                    resolution: 0.01,
                    unit: 500,
                    llod: undefined,
                    ulod: undefined
                },
                cl_mgm3: {
                    resolution: 0.01,
                    unit: 600,
                    llod: undefined,
                    ulod: undefined
                },
                co2_ppm: {
                    resolution: 1,
                    unit: 500,
                    llod: 0,
                    ulod: 5000
                },
                co2_mgm3: {
                    resolution: 1,
                    unit: 600,
                    llod: undefined,
                    ulod: undefined
                },
                co_ppm: {
                    resolution: 0.1,
                    unit: 500,
                    llod: 0,
                    ulod: 400
                },
                co_mgm3: {
                    resolution: 0.1,
                    unit: 600,
                    llod: undefined,
                    ulod: undefined
                },
                dewpoint: {
                    resolution: 0.1,
                    unit: 101,
                    llod: undefined,
                    ulod: undefined
                },
                h2s_ppm: {
                    resolution: 0.01,
                    unit: 500,
                    llod: 0,
                    ulod: 50
                },
                h2s_mgm3: {
                    resolution: 0.01,
                    unit: 600,
                    llod: undefined,
                    ulod: undefined
                },
                ncpm0x3: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000
                },
                ncpm0x5: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000
                },
                ncpm1x0: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000
                },
                ncpm2x5: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000
                },
                ncpm4x0: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000
                },
                ncpm10: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000
                },
                mcpm1x0: {
                    resolution: 1,
                    unit: 602,
                    llod: 0,
                    ulod: 500
                },
                mcpm2x5: {
                    resolution: 1,
                    unit: 602,
                    llod: 0,
                    ulod: 500
                },
                mcpm10: {
                    resolution: 1,
                    unit: 602,
                    llod: 0,
                    ulod: 500
                },
                no_ppm: {
                    resolution: 0.1,
                    unit: 500,
                    llod: 0,
                    ulod: 20
                },
                no_mgm3: {
                    resolution: 0.1,
                    unit: 600,
                    llod: undefined,
                    ulod: undefined
                },
                no2_ppm: {
                    resolution: 0.01,
                    unit: 500,
                    llod: 0,
                    ulod: 20
                },
                no2_mgm3: {
                    resolution: 0.01,
                    unit: 600,
                    llod: undefined,
                    ulod: undefined
                },
                o3_ppm: {
                    resolution: 0.01,
                    unit: 500,
                    llod: 0,
                    ulod: 20
                },
                o3_mgm3: {
                    resolution: 0.01,
                    unit: 600,
                    llod: undefined,
                    ulod: undefined
                },
                rh_percent: {
                    resolution: 0.1,
                    unit: 1301,
                    llod: 0,
                    ulod: 100
                },
                temp_c: {
                    resolution: 0.1,
                    unit: 101,
                    llod: 0,
                    ulod: 60
                },
                voc_ppm: {
                    resolution: 0.1,
                    unit: 500,
                    llod: 0,
                    ulod: 2000
                },
                voc_ppb: {
                    resolution: 10,
                    unit: 501,
                    llod: 0,
                    ulod: 20000
                },
                voc_mgm3: {
                    resolution: 0.01,
                    unit: 600,
                    llod: 0,
                    ulod: 1885
                },
                cl2_ppm: {
                    resolution: 0.01,
                    unit: 500,
                    llod: 0,
                    ulod: 20
                }
            }
        },
        {
            models: ['8143'],
            data: {
                mcpm1x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000,
                    unit: 602
                },
                mcpm2x5: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000,
                    unit: 602
                },
                mcpm4x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000,
                    unit: 602
                },
                mcpm10: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000,
                    unit: 602
                },
                ncpm0x5: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000,
                    unit: 511,
                },
                ncpm1x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000,
                    unit: 511
                },
                ncpm2x5: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000,
                    unit: 511
                },
                ncpm4x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000,
                    unit: 511
                },
                ncpm10: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000,
                    unit: 511
                },
                tpsize: {
                    resolution: 0.01,
                    llod: 0,
                    ulod: 10,
                    unit: 1001
                },
                temp_c: {
                    resolution: 0.1,
                    llod: -40,
                    ulod: 50,
                    ldl: -273.15,
                    udl: 3000,
                    unit: 101,
                },
                rh_percent: {
                    resolution: 1,
                    llod: 0,
                    ulod: 100,
                    ldl: 0,
                    udl: 100,
                    unit: 1301
                }
            }
        },
        {
            models: ['8145'],
            data: {
                mcpm1x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000,
                    unit: 602
                },
                mcpm2x5: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000,
                    unit: 602
                },
                mcpm4x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000,
                    unit: 602
                },
                mcpm10: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000,
                    unit: 602
                },
                ncpm0x5: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000,
                    unit: 511
                },
                ncpm1x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000,
                    unit: 511
                },
                ncpm2x5: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000,
                    unit: 511
                },
                ncpm4x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000,
                    unit: 511
                },
                ncpm10: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000,
                    unit: 511
                },
                tpsize: {
                    resolution: 0.01,
                    llod: 0,
                    ulod: 10,
                    unit: 1001
                },
                temp_c: {
                    resolution: 0.1,
                    llod: -40,
                    ulod: 50,
                    ldl: -273.15,
                    udl: 3000,
                    unit: 101
                },
                rh_percent: {
                    resolution: 1,
                    llod: 0,
                    ulod: 100,
                    ldl: 0,
                    udl: 100,
                    unit: 1301
                },
                baro_inhg: {
                    resolution: 0.01,
                    llod: 8,
                    ulod: 35,
                    ldl: 0,
                    udl: 37.2,
                    unit: 240
                },
                co2_ppm: {
                    resolution: 1,
                    llod: 0,
                    ulod: 10000,
                    ldl: 0,
                    udl: 10000,
                    unit: 500
                },
                co_ppm: {
                    resolution: 0.001,
                    llod: 0,
                    ulod: 20,
                    ldl: 0,
                    udl: 20,
                    unit: 500
                },
                o3_ppb: {
                    resolution: 1,
                    llod: 0,
                    ulod: 5000,
                    ldl: 0,
                    udl: 5000,
                    unit: 501
                },
                no2_ppb: {
                    resolution: 1,
                    llod: 0,
                    ulod: 5000,
                    ldl: 0,
                    udl: 5000,
                    unit: 501
                },
                so2_ppb: {
                    resolution: 1,
                    llod: 0,
                    ulod: 5000,
                    ldl: 0,
                    udl: 5000,
                    unit: 501
                }
            }
        },
        {
            models: ['8144-02'],
            data: {
                mcpm1x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000,
                    unit: 602
                },
                mcpm2x5: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000,
                    unit: 602
                },
                mcpm4x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000,
                    unit: 602
                },
                mcpm10: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000,
                    unit: 602
                },
                ncpm0x5: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000,
                    unit: 511
                },
                ncpm1x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000,
                    unit: 511
                },
                ncpm2x5: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000,
                    unit: 511
                },
                ncpm4x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000,
                    unit: 511
                },
                ncpm10: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000,
                    unit: 511
                },
                tpsize: {
                    resolution: 0.01,
                    llod: 0,
                    ulod: 10,
                    unit: 1001
                },
                temp_c: {
                    resolution: 0.1,
                    llod: -40,
                    ulod: 50,
                    ldl: -273.15,
                    udl: 3000,
                    unit: 101
                },
                rh_percent: {
                    resolution: 1,
                    llod: 0,
                    ulod: 100,
                    ldl: 0,
                    udl: 100,
                    unit: 1301
                },
                baro_inhg: {
                    resolution: 0.01,
                    llod: 7.7,
                    ulod: 37.2,
                    ldl: 0,
                    udl: 37.2,
                    unit: 240
                },
                co2_ppm: {
                    resolution: 1,
                    llod: 0,
                    ulod: 10000,
                    ldl: 0,
                    udl: 10000,
                    unit: 500
                },
                voc_ppb: {
                    resolution: 1,
                    llod: 0,
                    ulod: 20000,
                    ldl: 0,
                    udl: 20000,
                    unit: 501
                },
                voc_mgm3: {
                    resolution: 0.001,
                    llod: 0,
                    ulod: 3770,
                    ldl: 0,
                    udl: 3770,
                    unit: 600
                }
            }
        },
        {
            models: ['8144-04'],
            data: {
                mcpm1x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000,
                    unit: 602
                },
                mcpm2x5: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000,
                    unit: 602
                },
                mcpm4x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000,
                    unit: 602
                },
                mcpm10: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000,
                    unit: 602
                },
                ncpm0x5: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000,
                    unit: 511
                },
                ncpm1x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000,
                    unit: 511
                },
                ncpm2x5: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000,
                    unit: 511
                },
                ncpm4x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000,
                    unit: 511
                },
                ncpm10: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000,
                    unit: 511
                },
                tpsize: {
                    resolution: 0.01,
                    llod: 0,
                    ulod: 10,
                    unit: 1001
                },
                temp_c: {
                    resolution: 0.1,
                    llod: -40,
                    ulod: 50,
                    ldl: -273.15,
                    udl: 3000,
                    unit: 101
                },
                rh_percent: {
                    resolution: 1,
                    llod: 0,
                    ulod: 100,
                    ldl: 0,
                    udl: 100,
                    unit: 1301
                },
                baro_inhg: {
                    resolution: 0.01,
                    llod: 7.7,
                    ulod: 37.2,
                    ldl: 0,
                    udl: 37.2,
                    unit: 240
                },
                co2_ppm: {
                    resolution: 1,
                    llod: 0,
                    ulod: 10000,
                    ldl: 0,
                    udl: 10000,
                    unit: 500
                },
                voc_ppb: {
                    resolution: 1,
                    llod: 0,
                    ulod: 20000,
                    ldl: 0,
                    udl: 20000,
                    unit: 501
                },
                voc_mgm3: {
                    resolution: 0.001,
                    llod: 0,
                    ulod: 3770,
                    ldl: 0,
                    udl: 3770,
                    unit: 600
                },
                co_ppm: {
                    resolution: 0.1,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000,
                    unit: 500
                },
                ch2o_ppb: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000,
                    unit: 501
                }
            }
        },
        {
            models: ['8144-06'],
            data: {
                mcpm1x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000,
                    unit: 602
                },
                mcpm2x5: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000,
                    unit: 602
                },
                mcpm4x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000,
                    unit: 602
                },
                mcpm10: {
                    resolution: 1,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000,
                    unit: 602
                },
                ncpm0x5: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000,
                    unit: 511
                },
                ncpm1x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000,
                    unit: 511
                },
                ncpm2x5: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000,
                    unit: 511
                },
                ncpm4x0: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000,
                    unit: 511
                },
                ncpm10: {
                    resolution: 1,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000,
                    unit: 511
                },
                tpsize: {
                    resolution: 0.01,
                    llod: 0,
                    ulod: 10,
                    unit: 1001
                },
                temp_c: {
                    resolution: 0.1,
                    llod: -40,
                    ulod: 50,
                    ldl: -273.15,
                    udl: 3000,
                    unit: 101
                },
                rh_percent: {
                    resolution: 1,
                    llod: 0,
                    ulod: 100,
                    ldl: 0,
                    udl: 100,
                    unit: 1301
                },
                baro_inhg: {
                    resolution: 0.01,
                    llod: 7.7,
                    ulod: 37.2,
                    ldl: 0,
                    udl: 37.2,
                    unit: 240
                },
                co2_ppm: {
                    resolution: 1,
                    llod: 0,
                    ulod: 10000,
                    ldl: 0,
                    udl: 10000,
                    unit: 500
                },
                voc_ppb: {
                    resolution: 1,
                    llod: 0,
                    ulod: 20000,
                    ldl: 0,
                    udl: 20000,
                    unit: 501
                },
                voc_mgm3: {
                    resolution: 0.001,
                    llod: 0,
                    ulod: 3770,
                    ldl: 0,
                    udl: 3770,
                    unit: 600
                },
                co_ppm: {
                    resolution: 0.1,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000,
                    unit: 500
                },
                no2_ppb: {
                    resolution: 1,
                    llod: 0,
                    ulod: 20000,
                    ldl: 0,
                    udl: 20000,
                    unit: 501
                },
                so2_ppb: {
                    resolution: 1,
                    llod: 0,
                    ulod: 10000,
                    ldl: 0,
                    udl: 10000,
                    unit: 501
                },
                o3_ppb: {
                    resolution: 1,
                    llod: 0,
                    ulod: 20000,
                    ldl: 0,
                    udl: 20000,
                    unit: 501
                }
            }
        },
        {
            models: ['CEL620-A'],
            data: {
                lzs_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzi_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzs_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzi_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzeq: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzpeak: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lcs_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lcf_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lci_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lcs_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lcf_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lci_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lceq: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lcpeak: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                las_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                laf_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lai_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                las_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                laf_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lai_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                laeq: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lapeak: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                }
            }
        },
        {
            models: ['CEL620-B'],
            data: {
                lzs_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzi_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzs_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzi_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzeq: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzpeak: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lcs_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lcf_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lci_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lcs_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lcf_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lci_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lceq: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lcpeak: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                las_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                laf_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lai_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                las_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                laf_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lai_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                laeq: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lapeak: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf_max_16: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf_max_32: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf_max_64: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf_max_125: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf_max_250: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf_max_500: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf_max_1k: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf_max_2k: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf_max_4k: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf_max_8k: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzf_max_16k: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzs_max_16: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzs_max_32: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzs_max_64: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzs_max_125: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzs_max_250: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzs_max_500: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzs_max_1k: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzs_max_2k: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzs_max_4k: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzs_max_8k: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzs_max_16k: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzeq_16: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzeq_32: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzeq_64: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzeq_125: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzeq_250: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzeq_500: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzeq_1k: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzeq_2k: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzeq_4k: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzeq_8k: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                },
                lzeq_16k: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400
                }
            }
        },
        {
            models: ['7591-01'],
            data: {
                ncpm0x3: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000
                },
                ncpm0x5: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000
                },
                ncpm1x0: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000
                },
                ncpm2x5: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000
                },
                ncpm4x0: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000
                },
                ncpm10: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000
                },
                mcpm1x0: {
                    resolution: 1,
                    unit: 602,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000
                },
                mcpm2x5: {
                    resolution: 1,
                    unit: 602,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000
                },
                mcpm4x0: {
                    resolution: 1,
                    unit: 602,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000
                },
                mcpm10: {
                    resolution: 1,
                    unit: 602,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000
                }
            }
        },
        {
            models: ['7591-02'],
            data: {
                voc_ppm: {
                    resolution: 0.1,
                    unit: 500,
                    llod: 0,
                    ulod: 2000,
                    ldl: 0,
                    udl: 2000
                }
            }
        },
        {
            models: ['7591-03'],
            data: {
                voc_ppb: {
                    resolution: 1,
                    unit: 501,
                    llod: 0,
                    ulod: 20000,
                    ldl: 0,
                    udl: 20000
                }
            }
        },
        {
            models: ['7591-04'],
            data: {
                ncpm0x3: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000
                },
                ncpm0x5: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000
                },
                ncpm1x0: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000
                },
                ncpm2x5: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000
                },
                ncpm4x0: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000
                },
                ncpm10: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000
                },
                mcpm1x0: {
                    resolution: 1,
                    unit: 602,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000
                },
                mcpm2x5: {
                    resolution: 1,
                    unit: 602,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000
                },
                mcpm4x0: {
                    resolution: 1,
                    unit: 602,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000
                },
                mcpm10: {
                    resolution: 1,
                    unit: 602,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000
                },
                voc_ppm: {
                    resolution: 0.1,
                    unit: 500,
                    llod: 0,
                    ulod: 2000,
                    ldl: 0,
                    udl: 2000
                }
            }
        },
        {
            models: ['7591-05'],
            data: {
                ncpm0x3: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000
                },
                ncpm0x5: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000
                },
                ncpm1x0: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000
                },
                ncpm2x5: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000
                },
                ncpm4x0: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000
                },
                ncpm10: {
                    resolution: 0.1,
                    unit: 511,
                    llod: 0,
                    ulod: 3000,
                    ldl: 0,
                    udl: 3000
                },
                mcpm1x0: {
                    resolution: 1,
                    unit: 602,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000
                },
                mcpm2x5: {
                    resolution: 1,
                    unit: 602,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000
                },
                mcpm4x0: {
                    resolution: 1,
                    unit: 602,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000
                },
                mcpm10: {
                    resolution: 1,
                    unit: 602,
                    llod: 0,
                    ulod: 1000,
                    ldl: 0,
                    udl: 1000
                },
                voc_ppb: {
                    resolution: 1,
                    unit: 501,
                    llod: 0,
                    ulod: 20000,
                    ldl: 0,
                    udl: 20000
                },
                co2_ppm: {
                    resolution: 1,
                    unit: 500,
                    llod: 0,
                    ulod: 10000,
                    ldl: 0,
                    udl: 10000
                },
                temp_c: {
                    resolution: 0.1,
                    unit: 101,
                    llod: -40,
                    ulod: 125,
                    ldl: -273.15,
                    udl: 3000
                },
                rh_percent: {
                    resolution: 0.1,
                    unit: 1301,
                    llod: 0,
                    ulod: 100,
                    ldl: 0,
                    udl: 100
                },
                abs_pressure: {
                    resolution: 0.1,
                    unit: 212,
                    llod: 15,
                    ulod: 115,
                    ldl: 0,
                    udl: 120
                }
            }
        },
        {
            models: ['7591-06'],
            data: {
                co_ppm: {
                    resolution: 0.1,
                    unit: 500,
                    llod: 2,
                    ulod: 4500,
                    ldl: 0,
                    udl: 4500
                }
            }
        },
        {
            models: ['7591-07'],
            data: {
                ch2o_ppm: {
                    resolution: 0.01,
                    unit: 500,
                    llod: 5,
                    ulod: 1300,
                    ldl: 0,
                    udl: 1300
                }
            }
        },
        {
            models: ['7591-08'],
            data: {
                o3_ppm: {
                    resolution: 0.01,
                    unit: 500,
                    llod: 2,
                    ulod: 2500,
                    ldl: 0,
                    udl: 2500
                }
            }
        },
        {
            models: ['7591-09'],
            data: {
                lzs_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lzf_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lzi_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lzs_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lzf_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lzi_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lzeq: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lzpeak: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lcs_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lcf_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lci_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lcs_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lcf_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lci_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lceq: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lcpeak: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                las_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                laf_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lai_max: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                las_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                laf_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lai_min: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                laeq: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lapeak: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lzs: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lzf: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lzi: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lcs: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lcf: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lci: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                las: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                laf: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lai: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                laieq: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lae: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                laeq_t80: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                laft_m3: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                laft_m5: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lait_m3: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lait_m5: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lavg_1_t1nn_q1n: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lavg_2_t2nn_q2n: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lceq_laeq: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lex_8hr: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                lep_d: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                proj_lex_8hr: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                proj_lep_d: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                twa_8hr: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                proj_twa_8hr: {
                    resolution: 0.1,
                    llod: 20,
                    ulod: 140,
                    unit: 1400,
                    ldl: 0,
                    udl: 143.3
                },
                dose_percent: {
                    resolution: 0.1,
                    llod: 0,
                    ulod: 100000,
                    unit: 10,
                    ldl: 0,
                    udl: 100000
                },
                proj_dose_percent: {
                    resolution: 0.1,
                    llod: 0,
                    ulod: 100000,
                    unit: 10,
                    ldl: 0,
                    udl: 100000
                }
            }
        },
        {
            models: ['7591-10'],
            data: {
                cl_ppm: {
                    resolution: 0.01,
                    unit: 500,
                    llod: 1,
                    ulod: 2500,
                    ldl: 0,
                    udl: 2500
                }
            }
        },
        {
            models: ['7591-11'],
            data: {
                nh3_ppm: {
                    resolution: 0.1,
                    unit: 500,
                    llod: 5,
                    ulod: 1100,
                    ldl: 0,
                    udl: 1100
                }
            }
        },
        {
            models: ['8530', '8531', '8530EP', '8540', '8540-M', '8542-M'],
            data: {
                mcpm_total: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 400,
                    unit: 600
                },
                mcpm_total_min: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 400,
                    unit: 600
                },
                mcpm_total_max: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 400,
                    unit: 600
                },
                mcpm_total_avg: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 400,
                    unit: 600
                },
                mcpm_total_twa: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 400,
                    unit: 600
                },
                volumetric_flow: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 5,
                    llod: 0,
                    ulod: 5,
                    unit: 321
                },
                standard_flow: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 5,
                    llod: 0,
                    ulod: 5,
                    unit: 321
                },
                absolute_inlet_pressure: {
                    resolution: 0.01,
                    ldl: 0,
                    udl: 210,
                    llod: 0,
                    ulod: 210,
                    unit: 212
                },
                inlet_temp: {
                    resolution: 0.01,
                    ldl: 0,
                    udl: 423.15,
                    llod: 0,
                    ulod: 423.25,
                    unit: 102
                },
                outlet_temp: {
                    resolution: 0.01,
                    ldl: 0,
                    udl: 423.15,
                    llod: 0,
                    ulod: 423.25,
                    unit: 102
                },
                external_temp: {
                    resolution: 0.01,
                    ldl: 0,
                    udl: 423.15,
                    llod: 0,
                    ulod: 423.25,
                    unit: 102
                }
            }
        },
        {
            models: ['8532'],
            data: {
                mcpm_total: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm_total_min: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm_total_max: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm_total_avg: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm_total_twa: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                volumetric_flow: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 5,
                    llod: 0,
                    ulod: 5,
                    unit: 321
                },
                standard_flow: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 5,
                    llod: 0,
                    ulod: 5,
                    unit: 321
                },
                absolute_inlet_pressure: {
                    resolution: 0.01,
                    ldl: 0,
                    udl: 210,
                    llod: 0,
                    ulod: 210,
                    unit: 212
                },
                inlet_temp: {
                    resolution: 0.01,
                    ldl: 0,
                    udl: 423.15,
                    llod: 0,
                    ulod: 423.25,
                    unit: 102
                },
                outlet_temp: {
                    resolution: 0.01,
                    ldl: 0,
                    udl: 423.15,
                    llod: 0,
                    ulod: 423.25,
                    unit: 102
                },
                external_temp: {
                    resolution: 0.01,
                    ldl: 0,
                    udl: 423.15,
                    llod: 0,
                    ulod: 423.25,
                    unit: 102
                }
            }
        },
        {
            models: ['8533', '8533EP', '8534', '8543', '8543-M'],
            data: {
                mcpm1x0: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm2x5: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm4x0: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm10: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm_total: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm_total_min: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm_total_max: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm_total_avg: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm_total_twa: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm1x0_min: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm1x0_max: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm1x0_avg: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm1x0_twa: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm2x5_min: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm2x5_max: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm2x5_avg: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm2x5_twa: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm4x0_min: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm4x0_max: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm4x0_avg: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm4x0_twa: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm10_min: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm10_max: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm10_avg: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                mcpm10_twa: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 1000,
                    llod: 0,
                    ulod: 150,
                    unit: 600
                },
                volumetric_flow: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 5,
                    llod: 0,
                    ulod: 5,
                    unit: 321
                },
                standard_flow: {
                    resolution: 0.001,
                    ldl: 0,
                    udl: 5,
                    llod: 0,
                    ulod: 5,
                    unit: 321
                },
                absolute_inlet_pressure: {
                    resolution: 0.01,
                    ldl: 0,
                    udl: 210,
                    llod: 0,
                    ulod: 210,
                    unit: 212
                },
                inlet_temp: {
                    resolution: 0.01,
                    ldl: 0,
                    udl: 423.15,
                    llod: 0,
                    ulod: 423.25,
                    unit: 102
                },
                outlet_temp: {
                    resolution: 0.01,
                    ldl: 0,
                    udl: 423.15,
                    llod: 0,
                    ulod: 423.25,
                    unit: 102
                },
                external_temp: {
                    resolution: 0.01,
                    ldl: 0,
                    udl: 423.15,
                    llod: 0,
                    ulod: 423.25,
                    unit: 102
                }
            }
        }
    ];
    function getAllMetrology() {
        return hash;
    }
    function getModelsMetrology(model) {
        var hashItem = hash.find(function (item) {
            var models = item.models.map(function (model) { return model.toLowerCase(); });
            return (models.indexOf(model.toLowerCase()) >= 0);
        });
        return hashItem === null || hashItem === void 0 ? void 0 : hashItem.data;
    }
    function getMetrology(model, measurementType) {
        var deviceMetrology = getModelsMetrology(model);
        if (deviceMetrology != undefined) {
            var measurementMetrology = deviceMetrology[measurementType];
            return measurementMetrology;
        }
        return undefined;
    }

    var __extends = (window && window.__extends) || (function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null)
                throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var UnitConversionError = (function (_super) {
        __extends(UnitConversionError, _super);
        function UnitConversionError(message) {
            var _this = _super.call(this, message) || this;
            Object.setPrototypeOf(_this, UnitConversionError.prototype);
            return _this;
        }
        return UnitConversionError;
    }(Error));

    var __spreadArray = (window && window.__spreadArray) || function (to, from, pack) {
        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || Array.prototype.slice.call(from));
    };
    function _getSigDigitsLeftOfDecimalPoint(resolution) {
        var digits = 0;
        while (resolution >= 10) {
            digits++;
            resolution = resolution / 10;
        }
        if (resolution !== 1) {
            digits--;
        }
        return digits;
    }
    function _getSigDigitsRightOfDecimalPoint(resolution) {
        var digits = 0;
        while (resolution < 1) {
            digits++;
            resolution = 10 * resolution;
        }
        return digits;
    }
    function numberPrecision(value) {
        if (!isFinite(value) || value === 1) {
            return 0;
        }
        return (value >= 1) ? -_getSigDigitsLeftOfDecimalPoint(value) : _getSigDigitsRightOfDecimalPoint(value);
    }
    var Units = (function () {
        function Units() {
            this._unitsConvertMap = new Map();
            this._populateExportsMap();
        }
        Units.getInstance = function () {
            if (!Units.instance) {
                Units.instance = new Units();
            }
            return Units.instance;
        };
        Units.prototype.setPrecision = function (value, numDecimals, pad) {
            if (pad === void 0) { pad = true; }
            var precisionVal;
            precisionVal = setPrecision(value, numDecimals);
            if (numDecimals < 1) {
                precisionVal = precisionVal.toFixed(0);
            }
            else {
                precisionVal = (pad) ? precisionVal.toFixed(numDecimals) : precisionVal.toString();
            }
            return precisionVal;
        };
        Units.prototype._convert = function (from, to, value, precision) {
            if (precision === void 0) { precision = null; }
            var convertToFunction = this.getConvertFunction(from, to);
            if (convertToFunction !== null) {
                return convertToFunction(value, precision);
            }
            return null;
        };
        Units.prototype._convertBatch = function (from, to, values, precision) {
            if (precision === void 0) { precision = null; }
            var result = __spreadArray([], values, true);
            var convertToFunction = this.getConvertFunction(from, to, true);
            if (convertToFunction !== null) {
                convertToFunction(result, precision);
            }
            return result;
        };
        Units.prototype.convertResolution = function (fromUnit, toUnit, resolution) {
            if (isNaN(resolution) || resolution < 0) {
                throw new UnitConversionError('Resolution must be a positive value (>=0)');
            }
            var toResolution = resolution;
            if (fromUnit !== toUnit) {
                var val1 = this._convert(fromUnit, toUnit, resolution);
                var val2 = this._convert(fromUnit, toUnit, 0);
                if (val1 !== null && val2 !== null) {
                    toResolution = Math.abs(val1 - val2);
                }
            }
            return toResolution;
        };
        Units.prototype.convertUnit = function (fromUnit, toUnit, value, resolution, isAverage) {
            var result = value;
            if (fromUnit !== toUnit) {
                var converted = this._convert(fromUnit, toUnit, value);
                result = (converted !== null) ? converted : result;
            }
            if (resolution) {
                var toResolution = this.convertResolution(fromUnit, toUnit, resolution);
                var precision = numberPrecision(toResolution);
                if (isAverage) {
                    precision++;
                }
                result = Number(this.setPrecision(result, precision));
            }
            return result;
        };
        Units.prototype.convertUnitBatch = function (fromUnit, toUnit, values, resolution, isAverage) {
            var result = values;
            if (fromUnit !== toUnit) {
                result = this._convertBatch(fromUnit, toUnit, values);
            }
            if (resolution) {
                var toResolution = this.convertResolution(fromUnit, toUnit, resolution);
                var precision = numberPrecision(toResolution);
                if (isAverage) {
                    precision++;
                }
                for (var i = 0; i < values.length; i++) {
                    result[i] = Number(this.setPrecision(result[i], precision));
                }
            }
            return result;
        };
        Units.prototype.getConvertFunction = function (fromUnit, toUnit, batch) {
            var _a, _b;
            if (batch === void 0) { batch = false; }
            var convertFromMap = this._unitsConvertMap.get(fromUnit);
            if (convertFromMap !== undefined) {
                var converter = convertFromMap.get(toUnit);
                if (converter !== undefined) {
                    if (batch) {
                        return converter.convertBatchFunction;
                    }
                    else {
                        return converter.convertFunction;
                    }
                }
            }
            var fromUnitName = "".concat((_a = UnitOfMeasureProperties[fromUnit]) === null || _a === void 0 ? void 0 : _a.name, " (").concat(fromUnit, ")");
            var toUnitName = "".concat((_b = UnitOfMeasureProperties[toUnit]) === null || _b === void 0 ? void 0 : _b.name, " (").concat(toUnit, ")");
            throw new Error("FAILED TO FIND REQUESTED CONVERSION - FROM: ".concat(fromUnitName, " TO: ").concat(toUnitName));
        };
        Units.prototype.getMeasurementType = function (alias) {
            var paramMeasurement = this.getParamMeasurementType(alias);
            if (paramMeasurement)
                return paramMeasurement;
            for (var key in MeasurementTypes) {
                var measurement = MeasurementTypes[key];
                if (measurement.aliases.includes(alias)) {
                    return measurement;
                }
            }
        };
        Units.prototype.getParamMeasurementType = function (alias) {
            for (var key in ParamMeasurementTypes) {
                var measurement = ParamMeasurementTypes[key];
                if (alias.match(new RegExp(measurement.aliases[0], 'g'))) {
                    return measurement;
                }
            }
        };
        Units.prototype.getMetrology = function (model, measurementTypeName) {
            return getMetrology(model, measurementTypeName);
        };
        Units.prototype.getAllMetrology = function () {
            return getAllMetrology();
        };
        Units.prototype.getModelsMetrology = function (model) {
            return getModelsMetrology(model);
        };
        Units.prototype.convertToDisplay = function (value, upperLimit, lowerLimit, enforceUpperLimit) {
            if (enforceUpperLimit === void 0) { enforceUpperLimit = false; }
            if (enforceUpperLimit && upperLimit !== undefined && value > upperLimit) {
                return upperLimit;
            }
            if (lowerLimit !== undefined && value < lowerLimit) {
                return lowerLimit;
            }
            return value;
        };
        Units.prototype.convertUnitByMetrology = function (fromUnit, toUnit, value, metrology, enforceDisplayLimits, enforceUDL) {
            if (enforceDisplayLimits === void 0) { enforceDisplayLimits = true; }
            if (enforceUDL === void 0) { enforceUDL = false; }
            var numericValue = Number(value);
            var baseUnit = metrology.unit;
            var baseUnitLDL = metrology.ldl;
            var baseUnitUDL = metrology.udl;
            var baseUnitResolution = metrology.resolution;
            var fromUnitResolution = baseUnitResolution;
            var convertedValue = numericValue;
            if (fromUnit !== baseUnit) {
                fromUnitResolution = this.convertResolution(baseUnit, fromUnit, baseUnitResolution);
            }
            convertedValue = this.convertUnit(fromUnit, toUnit, numericValue, fromUnitResolution);
            if (enforceDisplayLimits) {
                var lowerDisplayLimit = undefined;
                var upperDisplayLimit = undefined;
                if (baseUnitLDL !== undefined) {
                    lowerDisplayLimit = this.convertUnit(baseUnit, toUnit, baseUnitLDL, baseUnitResolution);
                }
                if (baseUnitUDL !== undefined) {
                    upperDisplayLimit = this.convertUnit(baseUnit, toUnit, baseUnitUDL, baseUnitResolution);
                }
                convertedValue = this.convertToDisplay(convertedValue, upperDisplayLimit, lowerDisplayLimit, enforceUDL);
            }
            return convertedValue;
        };
        Units.prototype.convertPrecision = function (fromUnit, toUnit, resolution) {
            var toResolution = this.convertResolution(fromUnit, toUnit, resolution);
            return numberPrecision(toResolution);
        };
        Units.prototype._populateExportsMap = function () {
            var exportArray = [Temperature, Pressure, ParticleConcentration, ParticleMass, Gas, Volume];
            for (var _i = 0, exportArray_1 = exportArray; _i < exportArray_1.length; _i++) {
                var unitNamespace = exportArray_1[_i];
                var _loop_1 = function (convertClassName) {
                    var convertClass = unitNamespace[convertClassName];
                    var from = convertClass.getFrom();
                    var to = convertClass.getTo();
                    var currentToMap = this_1._unitsConvertMap.get(from);
                    var convertFunction = function (value, precision) {
                        return convertClass.convert(value, precision);
                    };
                    var convertBatchFunction = function (values, precision) {
                        convertClass.convertBatch(values, precision);
                    };
                    var converter = { convertFunction: convertFunction, convertBatchFunction: convertBatchFunction };
                    if (currentToMap !== undefined) {
                        currentToMap.set(to, converter);
                    }
                    else {
                        var newToMap = new Map();
                        newToMap.set(to, converter);
                        this_1._unitsConvertMap.set(from, newToMap);
                    }
                };
                var this_1 = this;
                for (var convertClassName in unitNamespace) {
                    _loop_1(convertClassName);
                }
            }
        };
        return Units;
    }());
    function getInstance() {
        return Units.getInstance();
    }

    exports.MeasurementTypes = MeasurementTypes;
    exports.UnitConversionError = UnitConversionError;
    exports.UnitOfMeasure = UnitOfMeasure$1;
    exports.UnitOfMeasureProperties = UnitOfMeasureProperties;
    exports.getInstance = getInstance;

}));
//# sourceMappingURL=units.js.map
